(function () {
  'use strict';

  angular
    .module('payviasmsClient', [
      'ngCookies',
      'ngSanitize',
      'restangular',
      'ui.router',
      'ui.router.stateHelper',
      'ui.bootstrap',
      'pascalprecht.translate',
      'validation.match',
      'ngTable',
      'angular-loading-bar',
      'internationalPhoneNumber',
      'uiSwitch',
      'angular-tabs',
      'ui.select',
      'disableAll',
      'angularMoment',
      'ngAnimate',
      'chart.js',
      'isteven-multi-select',
      'datePicker',
      'ngFlash',
      'ngMaterial',
      'vcRecaptcha'
    ]);

})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.clientSettlements',
        url: '/client/settlements',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/client/settlements/settlements.index.html',
            controller: 'ClientSettlementsController  as vm',
            data: {
              pageTitle: 'Rozliczenia',
              pageSubTitle: 'Rozliczenia'
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'realization.view'
      });

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.clientServices',
        url: '/client/services',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/client/services/services.index.html',
            controller: 'ServicesClientController as vm',
            data: {
              pageTitle: 'Usługi',
              pageSubTitle: 'Usługi'
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'service.view'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.clientProfile',
        url: '/client/profile',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/client/profile/profile.index.html',
            controller: 'ProfileController as vm',
            data: {
              pageTitle: 'Profil',
              pageSubTitle: 'Profil'
            },
            access: {
              loginRequired: false
            }
          }
        },
        permission: 'people.view'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.clientHistory',
        url: '/client/history',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/client/history/clientHistory.index.html',
            controller: 'ClientHistoryController as vm',
            data: {
              pageTitle: 'Historia',
              pageSubTitle: 'Historia'
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'sms.view'
      });

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .filter('Status', Status);

  function Status() {
    return function (status) {

      switch (status) {
        case null:
          status = 'Brak filtru';
          break;
        case true:
          status = 'Niewykorzystany';
          break;
        case false:
          status = 'Wykorzystany';
          break;
      }

      return status;

    };
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .filter('customNumber', customNumber);

  function customNumber() {
    return function (number) {
        var tmpAfterDot = ".00";
        if (angular.copy(parseFloat(number) == angular.copy(parseInt(number)))) {
          number = parseInt(number);
          number = number.toString();
        }
        else {
          number = number.toString();
          var tmpIndex = _.findIndex(number, function (value) {
            if (value == ',' || value == '.')
              return value;
          })
          tmpAfterDot = number.slice(tmpIndex);
          number = number.slice(0, tmpIndex)

        }
        inputSpaces();
      function inputSpaces() {

        if (number.length > 3)
        for (var i =  number.length-3; i>0; i -= 3) {
          if (number[i] != ' ')
            number = spliceSlice(number, i, number.length, " ");
        }
      }

      function spliceSlice(str, index, count, add) {
        if (index < 0) {
          index = str.length + index;
          if (index < 0) {
            index = 0;
          }
        }
        str = str.slice(0, index) + (add || "") + str.slice(index);
        return str;
      }

      return number+tmpAfterDot;

    };
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.dashboard',
        url: '/client/dashboard?:serviceId',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/client/dashboard/dashboard.index.html',
            controller: 'DashboardController as vm',
            data: {
              pageTitle: 'Pulpit',
              pageSubTitle: 'Pulpit'
            },
            access: {
              loginRequired: true
            }
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.clientApi',
        url: '/client/api',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/client/api/api.index.html',
            controller: 'ClientApiController as vm',
            data: {
              pageTitle: 'API',
              pageSubTitle: 'API'
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'permission.view'
      });

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.adminSettlements',
        url: '/admin/settlements',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/admin/settlements/settlements.index.html',
            controller: 'SettlementsController as vm',
            data: {
              pageTitle: 'Rozliczenia',
              pageSubTitle: 'Rozliczenia'
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'realization.viewAll'
      });

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .filter('SettlementsStatus', settlementsStatus);

  function settlementsStatus() {
    return function (status) {

      switch (status) {
        case 'N':
          status = 'Oczekiwanie na dokumenty';
          break;
        case 'A':
          status = 'Oczekiwanie na wypłatę';
          break;
        case 'O':
          status = 'Nieściągalne należności / sztuczny ruch (fraudy)';
          break;
        case 'W':
          status = 'Wypłata zrealizowana';
          break;
      }

      return status;

    };
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.adminServices',
        url: '/admin/services',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/admin/services/services.index.html',
            controller: 'ServicesController as vm',
            data: {
              pageTitle: 'Usługi',
              pageSubTitle: 'Usługi'
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'service.viewAll'
      });

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.profileAdmin',
        url: '/admin/profile',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/admin/profile/profile.index.html',
            controller: 'ProfileAdminController as vm',
            data: {
              pageTitle: 'Profil',
              pageSubTitle: 'Profil'
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'people.viewAll'
      });

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.adminHistory',
        url: '/admin/history',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/admin/history/history.index.html',
            controller: 'HistoryController as vm',
            data: {
              pageTitle: 'Historia ',
              pageSubTitle: 'Historia '
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'sms.viewAll'
      });

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .filter('Status', Status);

  function Status() {
    return function (status) {

      switch (status) {
        case null:
          status = 'Brak filtru';
          break;
        case true:
          status = 'Aktywny';
          break;
        case false:
          status = 'Nieaktywny';
          break;
      }

      return status;

    };
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.clientEventLog',
        url: '/admin/eventLog',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/admin/eventLog/eventLog.index.html',
            controller: 'ClientEventLogController as vm',
            data: {
              pageTitle: 'Logi',
              pageSubTitle: 'Logi'
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'permission.view'
      });

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'panel.adminClients',
        url: '/admin/clients',
        views: {
          'content': {
            templateUrl: 'app/routes/panel/admin/clients/clients.index.html',
            controller: 'ClientsController as vm',
            data: {
              pageTitle: 'Klienci',
              pageSubTitle: 'Klienci'
            },
            access: {
              loginRequired: true
            }
          }
        },
        permission: 'people.viewAll'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .filter('FinanceStatus', FinanceStatus);

  function FinanceStatus() {
    return function (status) {

      switch (status) {
        case 'A':
          status = 'Zatwierdzona';
          break;
        case 'N':
          status = 'Niezatwierdzona';
          break;
      }

      return status;

    };
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .filter('ClientsStatus', ClientsStatus);

  function ClientsStatus() {
    return function (status) {

      switch (status) {
        case 'B':
          status = 'Zablokowany';
          break;
        case 'A':
          status = 'Aktywny';
          break;
        case 'N':
          status = 'Nieaktywny';
          break;
      }

      return status;

    };
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ClientSettlementsController', ClientSettlementsController);

  /** @ngInject */
  function ClientSettlementsController($http, $cookies, NgTableParams,ENV) {
    var vm = this;

    vm.block = $cookies.getObject('userData');

    vm.userData = $cookies.getObject('userData');
    vm.getFinance = getFinance;
    vm.getRealization = getRealization;
    vm.all = allMoney;
    activate();

    function activate() {
      initTable();
      getRealization();
      getFinance();
    }

    function getFinance() {
      $http.get(ENV.api.url  + 'FinanceResource.php', {headers: $cookies.getObject('auth')})
        .then(function (data) {
          vm.formDataFinance = data.data;
        });
    }

    function allMoney() {

      $http.post(ENV.api.url  + 'RealizationResource.php?method=post',
        {
          "financeId": vm.formDataFinance.id
        },
        {headers: $cookies.getObject('auth')})
        .then(function () {
          getFinance();
          getRealization();
        }, function () {
          sweetAlert({title: "Błąd!", text: "Prosimy o kontakt z administracją!", timer: 2000, icon: "error"}); // eslint-disable-line
        })

    }


    function getRealization() {
      $http.get(ENV.api.url  + 'RealizationResource.php', {headers: $cookies.getObject('auth')})
        .then(function (data) {
          initTable();
          vm.formDataRealization = data.data;

          vm.formDataRealization.forEach(function (value) {
            if(value.realizationDate) value.realizationDate = value.realizationDate.substring(0, value.realizationDate.length - 1);
          });
          vm.searched = true;
          vm.tableParams.settings({
            page: 1,
            dataset: vm.formDataRealization
          });
        });
    }

    function initTable() {
      vm.tableParams = new NgTableParams({
        count: 5
      }, {
        counts: []
      });

    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ServicesClientController', ServicesClientController);


  /** @ngInject */
  function ServicesClientController(NgTableParams, $scope,ENV, $cookies, $filter, ModalService, $http) {
    var vm = this;
    vm.numshow = false;
    vm.blockGenerator = true;
    vm.form = {};

    vm.getAll = getAll;
    vm.activate = activate;
    vm.create = create;
    vm.dele = dele;
    vm.details = details;
    vm.getServicesForGenerator = getServicesForGenerator;
    vm.mappingForGenerator = mappingForGenerator;
    vm.disableGenerator = disableGenerator;
    vm.getNumbersForService = getNumbersForService;
    vm.generateSMS = generateSMS;
    vm.clearNotification = clearNotification;
    activate();

    function activate() {
      initTable();
      watch();
      getAll();
      getServicesForGenerator();

    }

    function clearNotification() {
      vm.generateSucces = 'dontShow';
    }

    function getServicesForGenerator() {
      vm.formServices = {};
      $http.get(ENV.api.url  + 'ServiceResource.php', {
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          angular.isArray(data.data) ?
            vm.serviceForGenerator = data.data :
            vm.serviceForGenerator = [];
          for (var i = 0; i < vm.serviceForGenerator.length; i++)
            vm.serviceForGenerator[i].theName = "[" + vm.serviceForGenerator[i].id + "]" + " " + vm.serviceForGenerator[i].name;
          delete vm.formServices;
        });
    }


    function mappingForGenerator() {
      vm.formDataGenerator = {};
      vm.formDataGenerator.serviceId = vm.form.serviceIdListFG.id;
      vm.formDataGenerator.numberId = vm.form.numIdsFG.id;
    }

    function disableGenerator(obj1, obj2) {
      vm.form.serviceIdListFG = undefined;
      vm.form.serviceIdListFG = obj1;
      vm.form.numIdsFG = undefined;
      vm.form.numIdsFG = obj2;

      if ((angular.isUndefined(vm.form.serviceIdListFG)) || (angular.isUndefined(vm.form.numIdsFG)))
        vm.blockGenerator = true;
      else vm.blockGenerator = (vm.form.numIdsFG.length < 0) || (vm.form.serviceIdListFG.length < 0);

    }

    function getNumbersForService(obj) {
      vm.form.serviceIdListFG = obj;
      vm.formGenerator = {};
      $http.get(ENV.api.url  + 'ServiceResource.php?id=' + obj.id, {headers: $cookies.getObject('auth')})
        .then(function (data) {
          vm.formGenerator.numbers = data.data.numbers;
          vm.numshow = true;
          vm.form.numIdsFG = undefined;
        });
    }

    function generateSMS() {
      vm.blockGenerator = true;
      mappingForGenerator();
      vm.searched = true;

      $http.post(ENV.api.url  + 'SMSResource.php?method=post',
        vm.formDataGenerator, {headers: $cookies.getObject('auth')})
        .then(function success(data) {
          if (angular.isDefined(data.data.Success)) {
            vm.temp = data.data;
            vm.generateSucces = 'created';
          }
          else
            vm.generateSucces = 'notCreated';
        })
        .finally(function () {
          vm.blockGenerator = false;
        })
    }

    function getAll() {
      $http.get(ENV.api.url  + 'ServiceResource.php', {headers: $cookies.getObject('auth')})
        .then(function (data) {
          vm.dane = data.data;
          vm.tableData = data.data;
          vm.tableParams.settings({
            page: 1,
            visibleColumnCount: vm.size,
            dataset: vm.tableData
          });
        });
      vm.style = {"display": "unset"};
    }

    function initTable() {
      vm.tableParams = new NgTableParams({
        count: 5
      }, {
        counts: []
      });

    }

    function watch() {
      $scope.$watch('vm.search', function (search) {
        var filteredData = search ? $filter('filter')(vm.peopleList, vm.search) : vm.peopleList;

        vm.tableParams.settings({dataset: filteredData});
        vm.tableParams.reload();
      });
    }

    function create() {
      var modalInstance = ModalService.form('app/routes/panel/client/services/services.create.html', null, 'ServicesClientCreateController');
      modalInstance.result.then(function () {
        activate();
      });
    }

    function details(id) {
      var obj = {
        id: id
      };
      ModalService.form('app/routes/panel/client/services/services.details.html', obj, 'ServicesClientDetailsController');
    }

    function dele(obj) {
      var modalInstance = ModalService.form('app/routes/panel/client/services/services.delete.html', obj, 'ServicesClientDeleteController');
      modalInstance.result.then(function () {
        activate();
      });
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ServicesClientDetailsController', ServicesClientDetailsController);

  /** @ngInject */
  function ServicesClientDetailsController($http, $uibModalInstance, $cookies, ENV) {

    var vm = this;

    vm.id = $uibModalInstance.formData.id;
    vm.selectedNumbers = '';

    vm.cancel = cancel;
    vm.ok = ok;
    vm.getAll = getAll;

    activate();

    function activate() {
      getAll();
    }

    function getAll() {
      $http.get(ENV.api.url + 'ServiceResource.php?id=' + vm.id, {headers: $cookies.getObject('auth')})
        .then(function (data) {
          vm.dane = data.data;
          vm.dane.numbers = _.map(vm.dane.numbers, "number");
        });
    }

    function ok() {
      $uibModalInstance.dismiss();
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ServicesClientDeleteController', ServicesClientDeleteController);


  /** @ngInject */
  function ServicesClientDeleteController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;

    activate();

    function activate() {
      vm.formData = $uibModalInstance.formData;
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function ok() {
      $http.post(ENV.api.url + 'ServiceResource.php?method=delete&id=' + vm.formData, null,
        {headers: $cookies.getObject('auth')})
        .then(function success() {
          sweetAlert({title: "Usługa Usunięta", time: 2000, icon: "success"}); // eslint-disable-line
          $uibModalInstance.close();
        }, function () {
          sweetAlert({title: "Błąd", time: 2000, icon: "error"}); // eslint-disable-line

        });
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ServicesClientCreateController', ServicesClientCreateController);

  /** @ngInject */
  function ServicesClientCreateController($http, $uibModalInstance, ENV, $filter, $cookies) {
    var vm = this;
    vm.ok = ok;
    vm.cancel = cancel;
    vm.activate = activate;
    vm.getNum = getNum;
    vm.CheckContent = CheckContent;
    vm.getNumA = getNumA;
    vm.check = true;
    vm.generate = 'A';
    vm.numbers = [];
    vm.responsecheck = true;
    vm.delWWW = delWWW;
    vm.addWeb = addWeb;
    vm.round = roundBrutto;
    vm.getNumIds = getNumIds;
    vm.clearNumbers = clearNumbers;
    vm.checkResponse = checkResponse;


    var userData = $cookies.getObject('userData');
    vm.localLang = {
      selectAll: $filter('translate')('Wybierz numer'),
      selectNone: $filter('translate')('Usun zaznaczone'),
      reset: $filter('translate')('Cofnij wszystko'),
      search: $filter('translate')('Szukaj'),
      nothingSelected: $filter('translate')('-- Wszystko --')
    };
    vm.formData = {};
    vm.formData.numbers = [];
    vm.www = [
      {'web': null}
    ];
    vm.classification = false;
    vm.formData.responseContent = "(Przykład) GetPay - dziekujemy za zakupy, twoj kod aktywacyjny to [kod].";
    activate();

    function activate() {
      getNum();
      getNumA();
    }

    function getNumIds() {
      for (var i = 0; i < vm.numbers.length; i++)
        vm.formData.numbers.push(vm.numbers[i].id);
    }

    function roundBrutto(value) {
      return '(' + $filter('number')(value * 1.23, 2) + 'zł brutto) ' + $filter('number')(userData.commission * value, 2) + 'zł prowizji'
    }

    function checkResponse() {
      for (var i = 0; i < vm.formData.responseContent.length; i++) {
        if (vm.formData.responseContent.substring(i, i + 5) === '[kod]') {
          vm.responsecheck = true;
          return 0;
        }
        else
          vm.responsecheck = false;
      }
    }

    function ok() {
      vm.formData.www = vm.www.map(function (el) {
        return el.web;
      });
      getNumIds();
      vm.classification ? vm.formData.classification = 't' : vm.formData.classification = 'f';
      $http.post(ENV.api.url + 'ServiceResource.php?method=post', vm.formData, {headers: $cookies.getObject('auth')})
        .then(function success() {
          sweetAlert({title: "Usługa utworzona i wysłana do weryfikacji, prosimy o oczekiwanie", time: 2000, icon: "success"}); // eslint-disable-line
          $uibModalInstance.close();
        })
    }

    function addWeb() {
      vm.www.push({'web': null});
    }

    function getNum() {
      $http.get(ENV.api.url + 'NumberResource.php?classification=f', {
        params: vm.numList,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.numListB = data.data;
          vm.numList = vm.numListB;
        });
    }

    function delWWW(index) {
      vm.www.splice(index, 1);
    }

    function getNumA() {
      $http.get(ENV.api.url + 'NumberResource.php?classification=t', {
        params: vm.numListA,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.numListA = data.data;
        });
    }

    function CheckContent(content) {
      $http.get(ENV.api.url + 'ServiceResource.php?content=' + content
        , {headers: $cookies.getObject('auth')})
        .then(function (data) {
          vm.check = data.data.status;
          vm.block = false;
        });
    }

    function clearNumbers(num) {
      if (num != vm.numList) {
        vm.numbers = '';
      }
    }

    vm.test = test;

    function test() {
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ProfileController', ProfileController)
    .filter('AccNum', function () {
      return function (number) {
        number = number.substring(0, 2) + ' ' + number.substring(2, 6) + ' ' + number.substring(6, 10)
          + ' ' + number.substring(10, 14) + ' ' + number.substring(14, 18) + ' ' + number.substring(18, 22)
          + ' ' + number.substring(22, 26);
        return number;
      }
    });

  /** @ngInject */
  function ProfileController($cookies, $http, $scope, $filter, ENV) {
    var vm = this;
    //deklaracja funkcji----------------------------------------------------------------------------------------------------------------
    vm.getOne = getOne;
    vm.changePassword = changePassword;
    vm.saveRealizationData = saveRealizationData;
    vm.save = save;
    vm.postPattern = postPattern;
    vm.edit = edit;
    vm.filter = getType();
    vm.cancelEdit = cancelEdit;
    vm.checkPlaceHolder = checkPlaceHolder;
    vm.inputSpaces = inputSpaces;

    //zmienne---------------------------------------------------------------------------------------------------------------------------
    vm.formDataCopy = {};
    vm.formDataInfo = {};
    vm.placeholder = {};
    vm.formDataInfo = $cookies.getObject('userData');
    vm.formData = $cookies.getObject('userData');
    inputSpaces();

    function checkPlaceHolder() {

      if (vm.formData.type === 'F') {
        vm.placeholder.name = 'Imie i Nazwisko';
        vm.placeholder.identification = 'Pesel';
      }
      if (vm.formData.type === 'P') {
        vm.placeholder.name = 'Nazwa Firmy';
        vm.placeholder.identification = 'NIP';
      }
    }

    vm.formDataPasswd = {};
    vm.accType = vm.formData.type;
    vm.checkpattern = true;
    vm.selected = 'person';
    vm.editing = false;
    vm.settEdit = false;

    //funkcje---------------------------------------------------------------------------------------------------------------------------
    activate();

    function inputSpaces() {
      for (var i = 0; i < vm.formData.bankAccountNumber.length; i++) {
        if (vm.formData.bankAccountNumber[i].charCodeAt(0) != 20 && (vm.formData.bankAccountNumber[i].charCodeAt(0) < 48 || vm.formData.bankAccountNumber[i].charCodeAt(0) > 57)) {
          vm.formData.bankAccountNumber = vm.formData.bankAccountNumber.slice(0, i) + vm.formData.bankAccountNumber.slice(i + 1, vm.formData.bankAccountNumber.length)
        }
      }

      if (vm.formData.bankAccountNumber.length > 2)
        if (vm.formData.bankAccountNumber[2] != ' ')
          vm.formData.bankAccountNumber = spliceSlice(vm.formData.bankAccountNumber, 2, vm.formData.bankAccountNumber.length, " ");
      for (i = 2; i < vm.formData.bankAccountNumber.length; i += 5) {
        if (vm.formData.bankAccountNumber[i] != ' ')
          vm.formData.bankAccountNumber = spliceSlice(vm.formData.bankAccountNumber, i, vm.formData.bankAccountNumber.length, " ");
      }
    }

    function spliceSlice(str, index, count, add) {
      if (index < 0) {
        index = str.length + index;
        if (index < 0) {
          index = 0;
        }
      }
      str = str.slice(0, index) + (add || "") + str.slice(index);
      return str;
    }


    function edit() {
      vm.editing = true;
    }

    function cancelEdit() {
      vm.editing = false;
      vm.formData = $cookies.getObject('userData');
      vm.formDataInfo = $cookies.getObject('userData');
      checkPlaceHolder();
      inputSpaces();
    }

    function activate() {
      typeof(!vm.formDataInfo) === "undefined" ? getOne(vm.formDataInfo.id) : null;
      checkPlaceHolder();
    }

    function postPattern() {
      if ((vm.formData.postalCode.length === 3) && (vm.checkpattern)) {
        var e, d;
        d = vm.formData.postalCode.substr(0, 2);
        e = vm.formData.postalCode.substr(2, 3);
        d = d.concat('-');
        d = d.concat(e);
        vm.formData.postalCode = d;
      }
      vm.checkpattern = vm.formData.postalCode.length !== 4;
    }

    function getOne(id) {
      $http.get(ENV.api.url + 'PeopleResource.php?id=' + id, {
        params: vm.formData,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.formData = data.data;
          $cookies.putObject("userData", vm.formData);
          vm.formDataCopy = angular.copy(vm.formData);
          inputSpaces();
          cancelEdit();
        });
    }

    function changePassword() {
      if (vm.passwd === vm.checkpasswd) {
        vm.formDataPasswd.password = vm.passwd;
        vm.formDataPasswd.oldPassword = CryptoJS.SHA1(vm.oldPassword).toString(); // eslint-disable-line

        $http.post(ENV.api.url + 'PeopleResource.php?method=changePassword', vm.formDataPasswd,
          {headers: $cookies.getObject('auth')})
          .then(function success() {
            sweetAlert({title: "Hasło zostało zmienione ", timer: 2000, icon: "success"}); // eslint-disable-line
            vm.oldPassword = "";
            vm.passwd = "";
            vm.checkpasswd = "";
          }, function () {
            sweetAlert({title: "Błąd", text: "Hasło nie zostało zmienione", timer: 2000, icon: "error"}); // eslint-disable-line
            vm.oldPassword = "";
            vm.passwd = "";
            vm.checkpasswd = "";

          })
      }
    }

    function save() {
      $http.post(ENV.api.url + 'PeopleResource.php?method=put&id=' + vm.formDataInfo.id, vm.formData,
        {headers: $cookies.getObject('auth')})
        .then(function success() {
          vm.msg = "Zmiany zostały zapisane";
          vm.formDataInfo = vm.formData;
          vm.formData.bankAccountNumber;
          vm.editing = false;
        })
        .finally(function () {
          getOne(vm.formDataInfo.id);
        });
    }


    function saveRealizationData() {
      vm.settEdit = false;
      if (vm.formData.type === 'P')
        vm.formDataRealization =
          {
            'nameIdentification': vm.formData.nameIdentification,
            'place': vm.formData.place,
            'taxOffice': vm.formData.taxOffice,
            'type': vm.formData.type,
            'specialType': vm.formData.specialType,
            'identification': vm.formData.identification
          };
      else
        vm.formDataRealization =
          {
            'type': vm.formData.type
          };
      $http.post(ENV.api.url + 'PeopleResource.php?method=data-realization&id=' + vm.formDataInfo.id, vm.formDataRealization,
        {headers: $cookies.getObject('auth')})
        .then(function success() {
          vm.msg = "Zmiany zostały zapisane";
          getOne(vm.formDataInfo.id);
          vm.formDataInfo = vm.formData;
          $cookies.putObject("userData", vm.formData);
        });
    }

    function getType() {
      return [
        {type: 'P'},
        {type: 'F'}
      ];
    }


  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ClientHistoryController', ClientHistoryController);


  /** @ngInject */
  function ClientHistoryController($http, NgTableParams, $filter, $cookies, ENV) {
    var vm = this;
    var dataT = new Date();
    var dataF = new Date();
    dataF = dataF.setDate(dataF.getDate() - 30);
    dataF = new Date(dataF);
    vm.openCalStart = false;
    vm.openCalEnd = false;
    vm.format = 'yyyy-MM-dd';
    vm.formData = {};
    vm.form = {};
    vm.tableData = [];
    vm.formData.status = null;
    vm.formData.dateTo = new Date();
    vm.formData.dateFrom = new Date();
    vm.statusList = getStatus();
    vm.date = new Date();
    vm.localLang = {
      selectAll: $filter('translate')('Wybierz numer'),
      selectNone: $filter('translate')('Usun zaznaczone'),
      reset: $filter('translate')('Cofnij wszystko'),
      search: $filter('translate')('Szukaj'),
      nothingSelected: $filter('translate')('-- Wszystko --')
    };
    vm.formData.dateFrom = dataF;
    vm.formData.dateTo = dataT;

    //_______________________________________________________
    vm.open = open;
    vm.open1 = open1;
    vm.getServices = getServices;
    vm.getNumA = getNumA;
    vm.getNum = getNum;
    vm.sort = sort;
    vm.getStatus = getStatus;
    vm.getHistory = getHistory;
    vm.mapping = mapping;

    activate();

    function activate() {
      getServices();
      getHistory();
      getNumA();
    }

    function getStatus() {
      return [
        {status: null},
        {status: true},
        {status: false}
      ];
    }

    function mapping() {
      vm.formData.serviceIdList = [];
      angular.isDefined(vm.form.serviceIdList) ? vm.formData.serviceIdList = _.map(vm.form.serviceIdList, 'id') : null;
      vm.formData.numberIdList = _.map(vm.form.numIds, 'id');
      vm.formData.serviceIdList.length === 0 ? delete vm.formData.serviceIdList : null;
      vm.formData.numberIdList.length <= 0 ? delete vm.formData.numberIdList : null;
      vm.formData.status === null ? delete vm.formData.status : null;
    }

    function getHistory() {
      vm.tableData = [];
      mapping();
      var obj = angular.copy(vm.formData);
      obj.dateFrom = moment(obj.dateFrom).add(-1 * (new Date().getTimezoneOffset()), 'm').toDate();
      obj.dateTo = moment(obj.dateTo).add(-1 * (new Date().getTimezoneOffset()), 'm').toDate();
      $http.post(ENV.api.url + 'SMSResource.php?method=history', obj, {headers: $cookies.getObject('auth')})
        .then(function (data) {
          initTable();
          vm.sorted = false;
          vm.history = data.data;
          vm.history.forEach(function (value) {
            value.sendDate = value.sendDate.substring(0, value.sendDate.length - 1);
          });
          vm.count = _.countBy(data.data, 'telephoneNumber');
          _.each(vm.history, function (value, key) { // eslint-disable-line
            _.each(vm.count, function (val, key2) {
              if (value.telephoneNumber == key2)
                value.count = val;
            })
          });
          vm.tableData = angular.copy(vm.history);
          vm.tableParams.settings({
            page: 1,
            dataset: vm.tableData
          });
        }).finally(function () {
        vm.tableParams.settings({
          page: 1,
          dataset: vm.tableData
        });
      })
    }

    function sort() {
      if (vm.sorted === false) {
        vm.sorted = true;
        vm.tableData = _.sortByOrder(vm.tableData, 'count', false);
        initTable();
        vm.tableParams.settings({
          page: 1,
          dataset: vm.tableData
        });
      }
      else {
        vm.sorted = false;
        initTable();
        vm.tableData = angular.copy(vm.history);
        vm.tableParams.settings({
          page: 1,
          dataset: vm.history
        });
      }
    }

    function getNum() {
      $http.get(ENV.api.url + 'NumberResource.php?classification=f', {
        params: vm.numList,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.numList = [];
          vm.numListB = data.data;
          if (angular.isArray(vm.numListB))
            vm.numList = vm.numListB;
          if (angular.isArray(vm.numListA))
            vm.numList = vm.numList.concat(vm.numListA)
        });
    }

    function getNumA() {
      $http.get(ENV.api.url + 'NumberResource.php?classification=t', {
        params: vm.numListA,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.numListA = data.data;
          getNum();
        });
    }

    function getServices() {
      $http.get(ENV.api.url + 'ServiceResource.php', {headers: $cookies.getObject('auth')})
        .then(function (data) {
          angular.isArray(data.data) ?
            vm.service = data.data :
            vm.service = [];
          for (var i = 0; i < vm.service.length; i++)
            vm.service[i].theName = "[" + vm.service[i].id + "]" + " " + vm.service[i].name;
        });
    }

    function initTable() {
      vm.tableParams = new NgTableParams({
        count: 20
      }, {
        counts: [20, 50, 100, 500, 1000]
      });

    }

    function open() {
      vm.openCalStart = !vm.openCalStart;
    }

    function open1() {
      vm.openCalEnd = !vm.openCalEnd;
    }
  }
})
();


(function () {

  'use strict';

  angular
    .module('payviasmsClient')
    .controller('DashboardController', DashboardController);


  /** @ngInject */
  function DashboardController(PermissionsService, ENV, $rootScope, $cookies, $http, NgTableParams,$stateParams,$state) {
    var vm = this;
    console.log($stateParams);
    vm.getChartData = getChartData;
    vm.getHistory = getHistory;
    vm.getAll = getAll;
    vm.series = ['Ilość Zrealizowanych Transakcji', 'Ilość Transakcji', 'Zysk'];
    vm.statistics = {
      saldo: 0,
      todayQuantity: 0,
      todayProfit: 0
    }
    vm.options = {
      scales: {
        yAxes: [{
          display: true,
          ticks: {
            suggestedMin: 0,    // minimum will be 0, unless there is a lower value.
            // OR //
            beginAtZero: true   // minimum value will be 0.
          }
        }]
      }
    };
    var dataT = new Date();
    var dataF = new Date();
    dataF = dataF.setDate(dataF.getDate() - 30);
    dataF = new Date(dataF);
    dataF = moment(dataF).add(-1 * (new Date().getTimezoneOffset()), 'm').toDate();
    dataT = moment(dataT).add(-1 * (new Date().getTimezoneOffset()), 'm').toDate();

    activate();

    function activate() {
      $rootScope.permissionList = $cookies.getObject('Permissions');
      initTable();
      PermissionsService.setPermissions($rootScope.permissionList);
      var id = $stateParams.serviceId || null;
      getServices();

      vm.selectedService = id;
      getChartData(id);
      getStatistics(id);
      getHistory(id);
    }
    function getAll(id,all) {
      if(!all)
      $state.go('panel.dashboard',{serviceId:id});
      else {
        $state.go('panel.dashboard',{serviceId:null});
      }

    }
    function getChartData(id) {

      var obj = {
        dateFrom: dataF,
        dateTo: dataT
      };
      if (id && id!=null) {
        obj.serviceIdList = [id]
      }
      $http.post(ENV.api.url + 'SMSResource.php?method=chart',
        obj
        , {headers: $cookies.getObject('auth')}
      )
        .then(function (data) {
          vm.chartData = data.data;
        })
        .finally(function () {

          vm.data = [[], [], []];
          vm.labels = [];
          var a = [];
          var b = [];
          var c = [];
          var d = [];
          vm.sumOfTransaction = 0;
          vm.sumOfProfits = 0;
          vm.sumOfRealizedTransaction = 0;
          for (var i = 0; i < vm.chartData.length; i++) {
            a.push(0);
            c.push(0);
            d.push(0);
            b.push('s');
            c[i] = vm.chartData[i].quantity;
            d[i] = vm.chartData[i].profit;
            b[i] = vm.chartData[i].date;
            vm.sumOfTransaction += vm.chartData[i].quantity;
            vm.sumOfProfits += parseFloat(vm.chartData[i].profit);
            vm.sumOfRealizedTransaction += vm.chartData[i].realizedQuantity;
          }
          vm.data[1] = vm.data[1].concat(c);
          vm.data[2] = vm.data[2].concat(d);
          vm.labels = vm.labels.concat(b);
          vm.searched = true;
          vm.sumOfProfits = vm.sumOfProfits.toFixed(2);

        });
    }

    function getStatistics(id) {
      var path = 'SMSResource.php?method=statistics';
      if (id != null && id)
        path += '&serviceId=' + id;
      $http.post(ENV.api.url + path, null, {
          headers: $cookies.getObject('auth')
        }
      )
        .then(function (data) {
          vm.statistics = data.data;
          vm.statistics.commission = parseFloat(vm.statistics.commission) * 100;
        });
    }


    function getServices() {
      vm.formServices = {};
      $http.get(ENV.api.url + 'ServiceResource.php', {
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          angular.isArray(data.data) ?
            vm.serviceList = data.data :
            vm.serviceList = [];
          delete vm.formServices;
        });
    }

    function getHistory(id) {

      var obj = {
        dateFrom: dataF,
        dateTo: dataT
      };
      if (id != null && id) {
        obj.serviceIdList = [id]
      }
      $http.post(ENV.api.url + 'SMSResource.php?method=history',
        obj, {headers: $cookies.getObject('auth')})
        .then(function success(data) {
          vm.history = data.data;
          vm.history.forEach(function (value) {
            value.sendDate = value.sendDate.substring(0, value.sendDate.length - 1);
          })
          vm.tableData = vm.history;
          vm.tableParams.settings({
            page: 1,
            dataset: vm.history
          });
        })
    }

    function initTable() {
      vm.tableParams = new NgTableParams({
        count: 5 // hides pager
      }, {
        counts: [] // hides page sizes
      });

    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ClientApiController', ClientApiController);

  /** @ngInject */
  function ClientApiController($cookies) {
    var vm = this;
    vm.formData = $cookies.getObject('userData');
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('SettlementsController', SettlementsController);


  /** @ngInject */
  function SettlementsController($http, ModalService, $cookies, NgTableParams, ENV) {
    var vm = this;
    vm.getFinance = getFinance;
    vm.getRealization = getRealization;
    vm.getPeople = getPeople;
    vm.activSett = activSett;
    vm.search = search;
    vm.add = add;
    vm.getRealizationNotConfirmed = getRealizationNotConfirmed;
    vm.dele = dele;
    vm.editStatus = editStatus;
    vm.formDataRealization = [];
    vm.edit = edit;
    vm.gotPeople = false;
    vm.searched = false;

    activate();

    function activate() {
      getPeople();
      getRealizationNotConfirmed();
    }

    function activSett(id) {
      vm.loading = true;
      $http.post(ENV.api.url + 'FinanceResource.php?id=' + id, {
        'status': 'A'
      }, {headers: $cookies.getObject('auth')})
        .then(function () {
          sweetAlert({ // eslint-disable-line
            title: "Sukces",
            text: "Aktywowano rozliczenia dla tego użytkownika.",
            timer: 2000,
            type: "success"
          }); // eslint-disable-line
        }, function () {
          sweetAlert({ // eslint-disable-line
            title: "Błąd", text: "W trakcie aktywacji rozliczeń. "// eslint-disable-line
            , timer: 5000, icon: "error"
          }); // eslint-disable-line

        })
        .finally(function () {
          vm.loading = false;
          getRealization(id);
          getFinance(id);
        })
    }

    function getPeople() {
      $http.get(ENV.api.url + 'PeopleResource.php', {
        params: vm.formData,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.people = data.data;
        });
    }

    function getFinance(id) {
      vm.formDataFinance = {};
      $http.get(ENV.api.url + 'FinanceResource.php?id=' + id, {
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.formDataFinance = data.data;
        });
    }

    function getRealization(id) {
      vm.formDataRealization = [];
      vm.searched = true;
      vm.gotPeople = true;
      $http.get(ENV.api.url + 'RealizationResource.php?id=' + id, {
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {

          vm.formDataRealization = data.data;
          initTable();
          vm.formDataRealization.forEach(function (value) {
            if (value.realizationDate && value.realizationDate != 'Z') value.realizationDate = value.realizationDate.substring(0, value.realizationDate.length - 1);
          });

          vm.tableParams.settings({
            page: 1,
            count: 5,
            counts: [],
            visibleColumnCount: vm.size,
            dataset: vm.formDataRealization
          });
        });
    }

    function getRealizationNotConfirmed() {
      vm.formDataRealization = [];
      $http.get(ENV.api.url + 'RealizationResource.php?status=N',
        {
          headers: $cookies.getObject('auth')
        })
        .then(function (data) {
          vm.formDataRealization = data.data;
          vm.formDataRealization.forEach(function (value) {
            if (value.realizationDate && value.realizationDate != 'Z') value.realizationDate = new Date(value.realizationDate);
          });
          vm.searched = true;
          vm.gotPeople = false;
          initTable();
          vm.tableParams.settings({
            page: 1,
            dataset: vm.formDataRealization,
            sorting: {
              name: 'asc'
            }

          });
        });
    }

    function initTable() {
      vm.tableParams = new NgTableParams({
        count: 5
      }, {
        counts: []
      });

    }


    function search(data) {
      var id = data.id;
      vm.currentUser = data;
      getRealization(id);
      getFinance(id);
    }

    function add(obj) {
      var modalInstance = ModalService.form('app/routes/panel/admin/settlements/settlements.add.html', obj, 'SettlementsAddController');

      modalInstance.result.then(function () {
        vm.search(vm.form.peopleId);
      });
    }

    function dele(obj) {
      var modalInstance = ModalService.form('app/routes/panel/admin/settlements/settlements.delete.html', obj, 'SettlementsDeleteController');

      modalInstance.result.then(function () {
        if (!vm.gotPeople)
          vm.getRealizationNotConfirmed();
        else
          vm.search(vm.form.peopleId);
      });
    }

    function editStatus(id, status, type) {
      var obj = {
        id: id,
        status: status,
        type: type
      };
      var modalInstance = ModalService.form('app/routes/panel/admin/settlements/settlements.editStatus.html', obj, 'SettlementsEditStatusController');

      modalInstance.result.then(function () {
        if (!vm.gotPeople)
          vm.getRealizationNotConfirmed();
        else
          vm.search(vm.form.peopleId);
      });
    }

    function edit(obj1, obj2, obj3) {
      var obj = {
        accountBalance: obj1,
        id: obj2,
        value: obj3
      };
      var modalInstance = ModalService.form('app/routes/panel/admin/settlements/settlements.edit.html', obj, 'SettlementsEditController');

      modalInstance.result.then(function () {
        vm.search(vm.form.peopleId);
      });
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('SettlementsEditStatusController', SettlementsEditStatusController);


  /** @ngInject */
  function SettlementsEditStatusController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;

    vm.cancel = cancel;
    vm.ok = ok;
    vm.form = {};
    activate();
    vm.status = getStatus();

    function activate() {
      vm.formData = $uibModalInstance.formData;
      vm.form.status = $uibModalInstance.formData.status;
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function getStatus() {
      if (vm.formData.type === 'F') {
        return [
          {status: 'O'},
          {status: 'W'},
          {status: 'A'}
        ];
      }
      else {
        return [
          {status: 'O'},
          {status: 'W'},
          {status: 'A'},
          {status: 'N'}
        ];
      }
    }

    function ok(status) {
      vm.loading = true;
      $http.post(ENV.api.url + 'RealizationResource.php?method=put&id=' + vm.formData.id, {
        'status': status
      }, {headers: $cookies.getObject('auth')})
        .then(function () {
          sweetAlert({title: "Sukces", text: "Zmieniono Status.", timer: 2000, icon: "success"}); // eslint-disable-line
          $uibModalInstance.close();
        }, function () {
          sweetAlert({title: "Błąd", text: "W trakcie zmiany statusu.", timer: 2000, icon: "error"}); // eslint-disable-line
        })
        .finally(function () {
          vm.loading = false;
        })
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('SettlementsEditController', SettlementsEditController);


  /** @ngInject */
  function SettlementsEditController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;
    vm.formData = {};
    vm.cancel = cancel;
    vm.ok = ok;
    vm.checkInput = checkInput;

    activate();

    function activate() {
      vm.indexData = $uibModalInstance.formData;
      vm.formData.value = vm.indexData.value;
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function checkInput() {
      if ((vm.formData.value > vm.indexData.accountBalance + $uibModalInstance.formData) || (vm.formData.value < 0)) {
        vm.formData.value = 0;
        vm.check = true;
        vm.disabled = true;
      }
      else
        vm.disabled = false;
    }

    function ok() {
      $http.post(ENV.api.url + 'RealizationResource.php?method=put&id=' + vm.indexData.id, vm.formData,
        {headers: $cookies.getObject('auth')})
        .then(function success() {
          $uibModalInstance.close();
        }, function () {
          sweetAlert({title: "Błąd", text: "W trakcie aktualizacji rozliczenia.", timer: 2000, icon: "error"}); // eslint-disable-line

        })
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('SettlementsDeleteController', SettlementsDeleteController);


  /** @ngInject */
  function SettlementsDeleteController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;

    vm.cancel = cancel;
    vm.ok = ok;

    activate();

    function activate() {
      vm.formData = $uibModalInstance.formData;
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function ok() {
      $http.post(ENV.api.url + 'RealizationResource.php?method=delete&id=' + vm.formData, null,
        {headers: $cookies.getObject('auth')})
        .then(function success() {
          $uibModalInstance.close();
        }, function () {
          sweetAlert({title: "Błąd", text: "W trakcie usuwania rozliczenia.", timer: 2000, icon: "error"}); // eslint-disable-line

        });
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('SettlementsAddController', SettlementsAddController);


  /** @ngInject */
  function SettlementsAddController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;

    vm.cancel = cancel;
    vm.ok = ok;
    vm.disabled = true;
    vm.checkInput = checkInput;

    activate();

    function activate() {
      vm.indexData = $uibModalInstance.formData;
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function checkInput() {
      if ((vm.formData.value > vm.indexData.accountBalance) || (vm.formData.value < 0) || (vm.formData.value < 100)) {
        vm.check = true;
        vm.disabled = true;
      }
      else
        vm.disabled = false;
    }

    function ok() {
      vm.formData.financeId = vm.indexData.id;
      vm.formData.value = parseFloat(vm.formData.value);

      $http.post(ENV.api.url + 'RealizationResource.php?method=post', vm.formData,
        {headers: $cookies.getObject('auth')})
        .then(function success() {
          $uibModalInstance.close();
        }, function () {
          sweetAlert({title: "Błąd", text: "W trakcie tworzenia rozliczenia.", timer: 2000, icon: "error"}); // eslint-disable-line

        })
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ServicesUpdatePrefixController', ServicesUpdatePrefixController);


  /** @ngInject */
  function ServicesUpdatePrefixController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;

    activate();

    function activate() {
      vm.formData = $uibModalInstance.formData;
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function ok() {
      $http.post(ENV.api.url + 'ServiceResource.php?method=prefix&id=' + vm.formData.id, {"prefix": vm.formData.prefix},
        {
          headers: $cookies.getObject('auth')
        })
        .then(function success() {
          $uibModalInstance.close();
        });
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ServicesController', ServicesController);


  /** @ngInject */
  function ServicesController(NgTableParams, ENV, $scope, $filter, ModalService, $http, $cookies) {
    var vm = this;
    vm.form = {};
    vm.blockGenerator = true;


    vm.dele = dele;
    vm.acti = acti;
    vm.deActi = deActi;
    vm.getAll = getAll;
    vm.updatePrefix = updatePrefix;
    vm.details = details;
    vm.control = control;
    vm.activate = activate;
    vm.mappingForGenerator = mappingForGenerator;
    vm.disableGenerator = disableGenerator;
    vm.getNumbersForService = getNumbersForService;
    vm.clearNotification = clearNotification;
    vm.generateSMS = generateSMS;
    vm.getServicesForGenerator = getServicesForGenerator;
    vm.getPeople = getPeople;

    activate();

    function activate() {
      initTable();
      watch();
      getAll();
      getServicesForGenerator();
      getPeople();
      $scope.$watch('vm.search', function () {
        if (angular.isDefined(vm.tableParams))
          vm.tableParams.reload();
      })
    }

    function mappingForGenerator() {
      vm.formDataGenerator = {};
      vm.formDataGenerator.serviceId = vm.form.serviceIdListFG.id;
      vm.formDataGenerator.numberId = vm.form.numIdsFG.id;
    }

    function disableGenerator(number) {
      if ((angular.isUndefined(vm.form.serviceIdListFG)) || (angular.isUndefined(number)))
        vm.blockGenerator = true;
      else vm.blockGenerator = (number.length < 0) || (vm.form.serviceIdListFG.length < 0);
    }

    function getNumbersForService(id) {
      vm.formGenerator = {};
      $http.get(ENV.api.url + 'ServiceResource.php?id=' + id, {headers: $cookies.getObject('auth')})
        .then(function (data) {
          vm.formGenerator.numbers = data.data.numbers;
          vm.numshow = true;
        });
    }

    function updatePrefix(row) {

      var modalInstance = ModalService.form('app/routes/panel/admin/services/services.updatePrefix.html', row, 'ServicesUpdatePrefixController');
      modalInstance.result.then(function () {
        getAll();
      });
    }

    function clearNotification() {
      vm.generateSucces = 'dontShow';
    }

    function generateSMS() {
      vm.block = true;
      mappingForGenerator();
      vm.searched = true;

      $http.post(ENV.api.url + 'SMSResource.php?method=post',
        vm.formDataGenerator, {headers: $cookies.getObject('auth')})
        .then(function success(data) {
          vm.temp = data.data;
          if (angular.isDefined(data.data.Success)) {
            vm.generateSucces = 'created';
          }
          else
            vm.generateSucces = 'notCreated';
        })
        .finally(function () {
          vm.block = false;

        })
    }

    function getServicesForGenerator(obj) {
      vm.serviceForGenerator = [];
      vm.form.peopleIdFG = obj;

      vm.formServices = {};
      if (angular.isDefined(vm.form.peopleIdFG)) {
        vm.formServices.peopleId = vm.form.peopleIdFG.id;
      }
      $http.get(ENV.api.url + 'ServiceResource.php', {
        params: vm.formServices,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          angular.isArray(data.data) ?
            vm.serviceForGenerator = data.data :
            vm.serviceForGenerator = [];
          for (var i = 0; i < vm.serviceForGenerator.length; i++)
            vm.serviceForGenerator[i].theName = "[" + vm.serviceForGenerator[i].id + "]" + " " + vm.serviceForGenerator[i].name;
          delete vm.formServices;
        });
    }

    function getPeople() {
      $http.get(ENV.api.url + 'PeopleResource.php', {
        params: vm.formData,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.people = data.data;
          for (var i = 0; i < vm.people.length; i++)
            vm.people[i].theName = "[" + vm.people[i].id + "]" + " " + vm.people[i].firstName + ' ' + vm.people[i].lastName;
        });
    }


    function getAll() {
      $http.get(ENV.api.url + 'ServiceResource.php', {
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.dane = data.data;
          vm.formData = data.data;
          initTable();
          vm.tableParams.settings({
            page: 1,
            dataset: data.data
          });
        });
      vm.style = {"display": "unset"};
    }

    function initTable() {
      vm.tableParams = new NgTableParams({
        count: 5
      }, {
        counts: []
      });

    }

    function watch() {
      $scope.$watch('vm.search', function (search) {
        var filteredData = search ? $filter('filter')(vm.peopleList, vm.search) : vm.peopleList;
        vm.tableParams.settings({dataset: filteredData});
        vm.tableParams.reload();
      });
    }

    function acti(obj) {

      $http.post(ENV.api.url + 'ServiceResource.php?method=put&id=' + obj.id, {"status": "A"},
        {
          headers: $cookies.getObject('auth')
        })
        .then(function success() {
          sweetAlert({title: "Usługa Aktywowana", time: 2000, icon: "success"}); // eslint-disable-line
          getAll();
        });

    }

    function deActi(obj) {

      $http.post(ENV.api.url + 'ServiceResource.php?method=put&id=' + obj.id, {status: "N"},
        {
          headers: $cookies.getObject('auth')
        })
        .then(function success() {
          sweetAlert({title: "Usługa Dezaktywowana", time: 2000, icon: "success"}); // eslint-disable-line
          getAll();
        });

    }

    function dele(obj) {
      var modalInstance = ModalService.form('app/routes/panel/admin/services/services.delete.html', obj, 'ServicesDeleteController');
      modalInstance.result.then(function () {
        getAll();
      });
    }

    function details(id) {
      var obj = {
        id: id
      };
      ModalService.form('app/routes/panel/admin/services/services.edit.html', obj, 'ServicesEditController');
    }

    function control(obj) {
      var modalInstance = ModalService.form('app/routes/panel/admin/services/services.control.html', obj, 'ServicesClientControlController');
      modalInstance.result.then(function () {
        getAll();
      });
    }

  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ServicesEditController', ServicesEditController);


  /** @ngInject */
  function ServicesEditController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;

    vm.id = $uibModalInstance.formData.id;
    vm.selectedNumbers = '';

    vm.cancel = cancel;
    vm.ok = ok;
    vm.getAll = getAll;

    activate();

    function activate() {
      getAll();
    }

    function getAll() {
      $http.get(ENV.api.url + 'ServiceResource.php?id=' + vm.id, {headers: $cookies.getObject('auth')})
        .then(function (data) {
          vm.dane = data.data;
          vm.dane.numbers = _.map(vm.dane.numbers, "number");
        });
    }

    function ok() {
      $uibModalInstance.dismiss();
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ServicesDeleteController', ServicesDeleteController);


  /** @ngInject */
  function ServicesDeleteController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;
    vm.cancel = cancel;
    vm.ok = ok;

    activate();

    function activate() {
      vm.formData = $uibModalInstance.formData;
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function ok() {
      $http.post(ENV.api.url + 'ServiceResource.php?method=delete&id=' + vm.formData.id, null,
        {headers: $cookies.getObject('auth')})
        .then(function () {
          $uibModalInstance.close();
        });
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ServicesClientControlController', ServicesClientControlController);

  /** @ngInject */
  function ServicesClientControlController($http, $uibModalInstance, $cookies, ENV) {

    var vm = this;

    vm.id = $uibModalInstance.formData;
    vm.formData = {};

    vm.cancel = cancel;
    vm.ok = ok;
    vm.send = send;

    activate();

    function activate() {

    }

    function send() {
      vm.status === true ? vm.formData.status = "A" : vm.formData.status = "N";
      vm.formData.serviceId = vm.id;
      $http.post(ENV.api.url + 'ActivationResource.php?method=post', vm.formData, {headers: $cookies.getObject('auth')})
        .then(function () {
          $uibModalInstance.close();
        });
    }

    function ok() {
      send();

    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ProfileAdminController', ProfileAdminController);


  /** @ngInject */
  function ProfileAdminController($cookies, $http, ENV) {
    var vm = this;
    //deklaracja funkcji----------------------------------------------------------------------------------------------------------------
    vm.getOne = getOne;
    vm.changePassword = changePassword;
    vm.clearInputs = clearInputs;
    //zmienne---------------------------------------------------------------------------------------------------------------------------
    vm.formDataCopy = {};
    vm.formDataInfo = $cookies.getObject('userData');
    vm.formDataPasswd = {};
    vm.checkpattern = true;
    vm.selected = 'person';
    //funkcje---------------------------------------------------------------------------------------------------------------------------
    activate();

    function activate() {
      getOne(vm.formDataInfo.id);
    }

    function getOne(id) {
      $http.get(ENV.api.url + 'PeopleResource.php?id=' + id, {
        params: vm.formData,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.formData = data.data;
          vm.formDataCopy = angular.copy(vm.formData);
        });
    }

    function changePassword() {
      vm.formDataPasswd.oldPassword = CryptoJS.SHA1(vm.oldPassword).toString(); // eslint-disable-line
      if (vm.passwd === vm.checkpasswd) {
        vm.formDataPasswd.password = vm.passwd;
        $http.post(ENV.api.url + 'PeopleResource.php?method=changePassword', vm.formDataPasswd,
          {headers: $cookies.getObject('auth')})
          .then(function success() {
            sweetAlert({title: "Hasło zostało zmienione ", timer: 2000, icon: "success"}); // eslint-disable-line
            vm.oldPassword = "";
            vm.passwd = "";
            vm.checkpasswd = "";
          }, function () {
            sweetAlert({title: "Błąd", text: "Hasło nie zostało zmienione", timer: 2000, icon: "error"}); // eslint-disable-line
            vm.oldPassword = "";
            vm.passwd = "";
            vm.checkpasswd = "";

          })
      }
      else
        vm.msg = 'Hasła nie są takie same';
    }

    function clearInputs(newType) {
      if (vm.formData.type !== newType) {
        if (newType === vm.formDataCopy.type) {
          vm.formData.nameIdentification = vm.formDataCopy.nameIdentification;
          vm.formData.identification = vm.formDataCopy.identification;
          vm.formData.specialType = vm.formDataCopy.specialType;
        } else {
          vm.formData.nameIdentification = '';
          vm.formData.identification = '';
          vm.formData.specialType = 'N';
        }
      }
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('HistoryController', HistoryController);


  /** @ngInject */
  function HistoryController($http, NgTableParams, $filter, $cookies, $scope, ENV) {
    var vm = this;
    var dataT = new Date();
    var dataF = new Date();
    dataF = dataF.setDate(dataF.getDate() - 30);
    dataF = new Date(dataF);

    vm.openCalStart = false;
    vm.openCalEnd = false;
    vm.format = 'yyyy-MM-dd';
    vm.formData = {};
    vm.form = {};
    vm.tableData = [];
    vm.formData.status = null;
    vm.formData30days = {};
    vm.statusList = getStatus();
    vm.formData.dateTo = new Date();
    vm.formData.dateFrom = new Date();
    vm.date = new Date();
    vm.localLang = {
      selectAll: $filter('translate')('Wybierz numer'),
      selectNone: $filter('translate')('Usun zaznaczone'),
      reset: $filter('translate')('Cofnij wszystko'),
      search: $filter('translate')('Szukaj'),
      nothingSelected: $filter('translate')('-- Wszystko --')
    };
    vm.formData.dateTo = dataT;
    vm.formData.dateFrom = dataF;
    vm.getStatus = getStatus;
    vm.getPeople = getPeople;
    vm.sort = sort;
    vm.open = open;
    vm.open1 = open1;
    vm.getServices = getServices;
    vm.getHistory = getHistory;
    activate();

    function activate() {
      getNumA();
      getPeople();
      getHistory();
      $scope.$watch('vm.search', function () {
        if (angular.isDefined(vm.tableParams))
          vm.tableParams.reload();
      })

    }

    function getStatus() {
      return [
        {status: null},
        {status: true},
        {status: false}
      ];
    }

    function mapping() {
      vm.formData.serviceIdList = [];
      typeof(vm.form.serviceIdList != 'undefined') ? vm.formData.serviceIdList = _.map(vm.form.serviceIdList, 'id') : null;
      vm.formData.peopleId = _.map(vm.form.peopleId, 'id');
      vm.formData.numberIdList = _.map(vm.form.numIds, 'id');
      vm.formData.serviceIdList.length == 0 ? delete vm.formData.serviceIdList : null;
      vm.formData.peopleId.length > 0 ? vm.formData.peopleId = vm.formData.peopleId[0] : delete vm.formData.peopleId;
      vm.formData.numberIdList.length <= 0 ? delete vm.formData.numberIdList : null;
    }

    function getHistory() {
      vm.tableData = [];
      mapping();
      vm.searched = true;
      var obj = angular.copy(vm.formData)
      obj.dateFrom = moment(obj.dateFrom).add(-1 * (new Date().getTimezoneOffset()), 'm').toDate();
      obj.dateTo = moment(obj.dateTo).add(-1 * (new Date().getTimezoneOffset()), 'm').toDate();
      $http.post(ENV.api.url + 'SMSResource.php?method=history',
        obj, {headers: $cookies.getObject('auth')})
        .then(function success(data) {
          initTable();
          vm.history = data.data;
          vm.history.forEach(function (value) {
            value.sendDate = value.sendDate.substring(0, value.sendDate.length - 1);
          })
          vm.tableData = vm.history;
          vm.count = _.countBy(data.data, 'telephoneNumber');
          _.each(vm.history, function (value, key) { // eslint-disable-line
            _.each(vm.count, function (val, key2) {
              if (value.telephoneNumber == key2)
                value.count = val;
            })
          })
          vm.tableData = angular.copy(vm.history);
          vm.tableParams.settings({
            page: 1,
            dataset: vm.tableData
          });
        }).finally(function () {
        vm.tableParams.settings({
          page: 1,
          dataset: vm.tableData
        });
      })
    }

    function sort() {
      if (vm.sorted === false) {
        vm.sorted = true;
        vm.tableData = _.sortByOrder(vm.tableData, 'count', false);
        initTable();
        vm.tableParams.settings({
          page: 1,
          dataset: vm.tableData
        });
      }
      else {
        vm.sorted = false;
        initTable();
        vm.tableData = angular.copy(vm.history);
        vm.tableParams.settings({
          page: 1,
          dataset: vm.history
        });
      }
    }

    function getPeople() {
      $http.get(ENV.api.url + 'PeopleResource.php', {
        params: vm.formData,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.people = data.data;
          for (var i = 0; i < vm.people.length; i++)
            vm.people[i].theName = "[" + vm.people[i].id + "]" + " " + vm.people[i].firstName + ' ' + vm.people[i].lastName;
        });
    }

    function getNum() {
      $http.get(ENV.api.url + 'NumberResource.php?classification=f', {
        params: vm.numList,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.numList = [];
          vm.numListB = data.data;
          if (angular.isArray(vm.numListB))
            vm.numList = vm.numListB;
          if (angular.isArray(vm.numListA))
            vm.numList = vm.numList.concat(vm.numListA)

        });
    }

    function getNumA() {
      $http.get(ENV.api.url + 'NumberResource.php?classification=t', {
        params: vm.numListA,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.numListA = data.data;
          getNum();
        });
    }

    function getServices(obj) {

      vm.formServices = {};
      vm.service = [];
      vm.formData.peopleId = obj.id;
      vm.point = true;
      vm.formServices.peopleId = vm.formData.peopleId;
      $http.get(ENV.api.url + 'ServiceResource.php', {
        params: vm.formServices,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          angular.isArray(data.data) ?
            vm.service = data.data :
            vm.service = [];
          for (var i = 0; i < vm.service.length; i++)
            vm.service[i].theName = "[" + vm.service[i].id + "]" + " " + vm.service[i].name;
        });
    }

    function initTable() {
      vm.tableParams = new NgTableParams({
        count: 20
      }, {
        counts: [20, 50, 100, 500, 1000]
      });

    }

    function open() {
      vm.openCalStart = !vm.openCalStart;
    }

    function open1() {
      vm.openCalEnd = !vm.openCalEnd;
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ClientEventLogController', ClientEventLogController)
    .filter('eventLog', function ($filter) {
      return function (value) {
        var isIp = false;
        var retu;
        for (var i = 0; i < value.length; i++) {
          if (value[i] === '[')
            isIp = true;
        }
        if (isIp)
          retu = $filter('translate')(value.substring(0, 4)) + ', ' + $filter('translate')(value.substring(5));
        else retu = $filter('translate')(value);
        return retu;
      }
    });

  /** @ngInject */
  function ClientEventLogController($http, NgTableParams, $filter, $cookies, ENV) {
    var vm = this;
    var data = $cookies.getObject('userData');
    vm.date = new Date();
    vm.localLang = {
      selectAll: $filter('translate')('Wybierz numer'),
      selectNone: $filter('translate')('Usun zaznaczone'),
      reset: $filter('translate')('Cofnij wszystko'),
      search: $filter('translate')('Szukaj'),
      nothingSelected: $filter('translate')('-- Wszystko --')
    };

    vm.getAll = getAll;
    activate();

    function activate() {
      getPeople();
      getAll(data.id)
    }

    function getPeople() {
      $http.get(ENV.api.url + 'PeopleResource.php', {
        params: vm.formData,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.people = data.data;
        });
    }

    function getAll(id) {
      $http.get(ENV.api.url + 'PeopleResource.php?method=history&id=' + id, {
        params: vm.numList,
        headers: $cookies.getObject('auth')
      })
        .then(function success(data) {
          initTable();
          vm.history = data.data;
          vm.tableData = data.data;
          vm.history.forEach(function (value) {
            value.date = value.date.substring(0, value.date.length - 1);
          })
          vm.tableParams.settings({
            dataset: vm.history
          });
        })
    }

    function initTable() {

      vm.tableParams = new NgTableParams({
        count: 5
      }, {
        counts: []
      });
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ClientVerifyController', ClientVerifyController);

  /** @ngInject */
  function ClientVerifyController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;

    vm.cancel = cancel;
    vm.ok = ok;
    vm.status = getStatus();
    vm.formData = {};
    activate();

    function activate() {
      vm.formData.status = $uibModalInstance.formData.financeStatus;
      vm.id = $uibModalInstance.formData.id;
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function getStatus() {
      return [
        {status: 'N'},
        {status: 'A'}
      ];
    }

    function ok() {
      $http.post(ENV.api.url + 'FinanceResource.php?method=post&id=' + vm.id, vm.formData, {
        headers: $cookies.getObject('auth')
      })
        .then(function () {
          $uibModalInstance.close();
        }, function () {
          sweetAlert({title: "Błąd", timer: 2000, icon: "error"}); // eslint-disable-line
        });
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ClientsController', ClientsController);

  /** @ngInject */
  function ClientsController(NgTableParams, $scope, $filter, ModalService, $http, $cookies, ENV) {
    var vm = this;

    vm.dele = dele;
    vm.edit = edit;
    vm.verify = verify;
    vm.getAll = getAll;
    activate();

    function activate() {
      initTable();
      watch();
      getAll();
    }

    function getAll() {
      $http.get(ENV.api.url + 'PeopleResource.php', {
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.dane = data.data;
          vm.formData = data.data;
          if (data.data.Warning) {
            vm.tableParams.settings({
              page: 1,
              dataset: []
            })
          } else {
            vm.tableParams.settings({
              page: 1,
              dataset: data.data
            });
          }
        });
      vm.style = {"display": "unset"};
    }

    function initTable() {
      vm.tableParams = new NgTableParams({
        count: 5
      }, {
        counts: []
      });

    }

    function watch() {
      $scope.$watch('vm.search', function (search) {
        var filteredData = search ? $filter('filter')(vm.peopleList, vm.search) : vm.peopleList;

        vm.tableParams.settings({dataset: filteredData});
        vm.tableParams.reload();
      });
    }

    function edit(obj) {
      var modalInstance = ModalService.form('app/routes/panel/admin/clients/clients.edit.html', obj, 'ClientEditController');
      modalInstance.result.then(function () {
        getAll();
      });
    }

    function verify(obj) {
      var modalInstance = ModalService.form('app/routes/panel/admin/clients/clients.verify.html', obj, 'ClientVerifyController');
      modalInstance.result.then(function () {
        getAll();
      });
    }

    function dele(obj) {
      var modalInstance = ModalService.form('app/routes/panel/admin/clients/clients.delete.html', obj, 'ClientDeleteController');
      modalInstance.result.then(function () {
        getAll();
      });
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ClientEditController', ClientEditController);

  /** @ngInject */
  function ClientEditController($uibModalInstance, $cookies, $http, ENV) {
    var vm = this;
    vm.statusList = getStatus();
    vm.checkpattern = true;
    vm.formDataToString = {};
    vm.formData = $uibModalInstance.formData;

    vm.getStatus = getStatus;
    vm.cancel = cancel;
    vm.getOne = getOne;
    vm.postPattern = postPattern;
    vm.ok = ok;
    vm.change = change;

    activate();

    function activate() {

      getOne(vm.formData.id);
    }

    function change() {
      if (vm.formDataToString.commission > 100) {
        vm.formDataToString.commission = 100;
      }
      if (vm.formDataToString.commission < 0)
        vm.formDataToString.commission = 0;
    }

    function postPattern() {

      if ((vm.formData.postalCode.length === 3) && (vm.checkpattern)) {
        var e, d;
        d = vm.formData.postalCode.substr(0, 2);
        e = vm.formData.postalCode.substr(2, 3);
        d = d.concat('-');
        d = d.concat(e);
        vm.formData.postalCode = d;
      }
      vm.checkpattern = vm.formData.postalCode.length !== 4;
    }

    function getOne(id) {
      $http.get(ENV.api.url + 'PeopleResource.php?id=' + id, {
        params: vm.formData,
        headers: $cookies.getObject('auth')
      })
        .then(function (data) {
          vm.formData = data.data;
          vm.formDataToString.commission = parseFloat(vm.formData.commission) * 100;
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function ok() {
      vm.formData.commission = (vm.formDataToString.commission / 100).toString();
      vm.status = {'status': vm.formData.status};
      delete vm.formData.status;
      $http.post(ENV.api.url + 'PeopleResource.php?method=put&id=' + vm.formData.id, vm.formData, {
        headers: $cookies.getObject('auth')
      })
        .then(function () {
          $http.post(ENV.api.url + 'PeopleResource.php?method=changeStatus&id=' + vm.formData.id, vm.status, {
            headers: $cookies.getObject('auth')
          })
            .then(function () {
              $uibModalInstance.close();
            })
        });
    }

    function getStatus() {
      return [
        {status: 'B'},
        {status: 'A'},
        {status: 'N'}
      ];
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ClientDeleteController', ClientDeleteController);

  /** @ngInject */
  function ClientDeleteController($uibModalInstance, $http, $cookies, ENV) {
    var vm = this;

    vm.cancel = cancel;
    vm.ok = ok;

    activate();

    function activate() {
      vm.formData = $uibModalInstance.formData;
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function ok() {
      $http.post(ENV.api.url + 'PeopleResource.php?method=delete&id=' + vm.formData.id, null, {
        headers: $cookies.getObject('auth')
      })
        .then(function () {
          $uibModalInstance.close();
        });
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'error.Error401',
        url: '/error/Error401',
        views: {
          'content': {
            templateUrl: 'app/routes/error/401/error401.index.html',
            controller: 'Error401Controller as vm',
            data: {
              pageTitle: 'Error 401',
              pageSubTitle: 'Error 401'
            },
            access: {
              loginRequired: false
            }
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'auth.signup',
        url: '/auth/signup',
        views: {
          'content': {
            templateUrl: 'app/routes/auth/signup/signup.index.html',
            controller: 'SignupController as vm',
            data: {
              pageTitle: 'Rejestracja',
              pageSubTitle: 'Rejestracja'
            },
            access: {
              loginRequired: false
            }
          }
        }
      });

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .filter('SingUpType', SingUpType);

  function SingUpType() {
    return function (type) {

      switch (type) {
        case 'P':
          type = 'Konto firmowe';
          break;
        case 'F':
          type = 'Konto prywatne';
          break;
      }

      return type;

    };
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'auth.signin',
        url: '/auth/signin',
        views: {
          'content': {
            templateUrl: 'app/routes/auth/signin/signin.index.html',
            controller: 'SigninController as vm',
            data: {
              pageTitle: 'Logowanie',
              pageSubTitle: 'Logowanie'
            },
            access: {
              loginRequired: false
            }
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
        name: 'auth.passw',
        url: '/auth/password',
        views: {
          'content': {
            templateUrl: 'app/routes/auth/passw/passw.index.html',
            controller: 'PasswController as vm',
            data: {
              pageTitle: 'Odzyskiwanie hasła',
              pageSubTitle: 'Odzyskiwanie hasła'
            },
            access: {
              loginRequired: false
            }
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig(stateHelperProvider) {

    stateHelperProvider
      .state({
          name: 'auth.activation',
          url: '/auth/activation?:id&:token',
          views: {
            'content': {
              templateUrl: 'app/routes/auth/activation/activation.index.html',
              controller: 'ActivationController as vm',
              data: {
                pageTitle: 'Aktywacja Konta',
                pageSubTitle: 'Aktywacja Konta'
              },
              access: {
                loginRequired: false
              }

            }
          },
          children: [
            {
              name: 'id'
            },
            {
              name: 'token'
            }
          ]
        },
        {siblingTraversal: true});

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('HeaderController', HeaderController);

  /** @ngInject */
  function HeaderController($http, $state, $cookies,ENV) {
    var vm = this;
    vm.logOut = logOut;
    vm.setHidden = setHidden;
    vm.collapsed = false;
    vm.active = -1;
    vm.formDataInfo = $cookies.getObject('userData');
    if(angular.isDefined($cookies.getObject('hiddenInfo')))
      vm.show = false;
    else vm.show = angular.isDefined($cookies.getObject('userData'))?$cookies.getObject('userData').financeStatus === 'N': false;


    function setHidden() {
      var expireDate = new Date();
      expireDate.setSeconds(expireDate.getSeconds() + 1800);
      $cookies.putObject('hiddenInfo',{HiddeInfo:true},{expires:expireDate});
    }

    function logOut() {
      $http.post(ENV.api.url  + 'PeopleResource.php?method=logOut', null, {headers: $cookies.getObject('auth')})
        .then(function success(response) {
          var msgA = response.data;
          var msg = angular.toJson(msgA);

          if (msg === '{"Error":"Error during logout"}') {
            msg = "Blad!"
          }
          else {
            $cookies.remove('userData');
            $cookies.remove('permission');
            $cookies.remove('PHPSESSID');
            $cookies.remove('hiddenInfo');
            $cookies.remove('auth');
            $state.go('auth.signin')
          }
        }, function () {
          $cookies.remove('userData');
          $cookies.remove('permission');
          $cookies.remove('PHPSESSID');
          $cookies.remove('hiddenInfo');
          $cookies.remove('auth');
          $state.go('auth.signin')
        })
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('FooterController', FooterController);

  /** @ngInject */
  function FooterController() {
    var vm = this;
    vm.year = new Date().getFullYear();
  }
})();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('Error401Controller', Error401Controller);


  /** @ngInject */
  function Error401Controller($rootScope,$state,$cookies,$http,ENV) {
    var vm = this;
    vm.formData = $cookies.getObject('userData');
    vm.toLogin =toLogin;


      function toLogin() {


      if(typeof(vm.formData)!='undefined' ) {
        $http.get(ENV.api.url  + 'PeopleResource.php?id=' + vm.formData.id, {
          headers: $cookies.getObject('auth')
        })
          .then(function () {
            $state.go('panel.dashboard')
          }, function () {
            $cookies.remove('userData');
            $cookies.remove('permissions');
            $cookies.remove('PHPSESSID');
            $cookies.remove('auth');
            $state.go('auth.signin')
          })
      }
      else
      {
        $cookies.remove('userData');
        $cookies.remove('permissions');
        $cookies.remove('PHPSESSID');
        $cookies.remove('auth');
        $state.go('auth.signin')}

      }

    }

})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('SignupController', SignupController);

  /** @ngInject */
  function SignupController($http, $state, $filter,vcRecaptchaService,ENV) {
    var vm = this;

    // ________________________________________________________________________ public
    vm.formData = {};
    vm.formData.type = 'P';
    vm.placeholder = {};
    vm.checkpattern = true;
    vm.response = null;
    vm.block = false;
    vm.filter = getType();

    //-------------------------------------------------------------------------
    vm.register = register;
    vm.postPattern = postPattern;
    vm.changeType = changeType;
    activate();
    vm.year = new Date().getFullYear();

    function activate() {
      changeType();
    }

    vm.setResponse = function (response) {
      vm.response = response;
    };

    function changeType() {
      if (vm.formData.type === 'F') {
        vm.placeholder.name = 'Imię i nazwisko';
        vm.placeholder.identification = 'PESEL';
      }
      if (vm.formData.type === 'P') {
        vm.placeholder.name = 'Pełna nazwa firmy';
        vm.placeholder.identification = 'NIP';
      }
    }

    function getType() {
      return [
        {type: 'P'},
        {type: 'F'}
      ];
    }

    function postPattern() {

      if ((vm.formData.postalCode.length === 3) && (vm.checkpattern)) {
        var e, d;
        d = vm.formData.postalCode.substr(0, 2);
        e = vm.formData.postalCode.substr(2, 3);
        d = d.concat('-');
        d = d.concat(e);
        vm.formData.postalCode = d;
      }
      vm.checkpattern = vm.formData.postalCode.length !== 4;
    }

    function register() {
      vm.block = true;
      vm.type ? vm.formData.type = 'P' : null;
      vm.formData.mail = $filter('lowercase')(vm.formData.mail);
      $http.post(ENV.api.url  + 'PeopleResource.php?method=post', vm.formData)
        .then(function () {
          sweetAlert({// eslint-disable-line
              title: "Sukces!",
              text: "Konto zostało utworzone, na adres e-mail podany podczas rejestracji został wysłany link aktywacyjny konto.",
              timer: 8000,
              icon: "success"
            }
          );
          $state.go('auth.signin');

        }, function (e) {
          vm.formData.recaptcha =null;
          vcRecaptchaService.reload(vm.widgetId);
          vm.errors = e.data.errors;
          if (e.data.Error === "Mail already exist")
            sweetAlert({title: "Błąd!", text: "Adres e-mail, który wprowadzasz już istnieje.", timer: 8000, icon: "error"}); // eslint-disable-line
          else
            sweetAlert({title: "Błąd!", text: "Prosimy o kontakt z administracją.", timer: 8000, icon: "error"}); // eslint-disable-line


        })
        .finally(function () {
          vm.block = false;
        });
    }
  }
})();


(function () {
  'use strict';
//TODO error  You should use the function syntax for DI  angular/di
  angular// eslint-disable-line
    .module('payviasmsClient')
    .config(['$httpProvider', function ($httpProvider) {
      $httpProvider.defaults.withCredentials = true;
    }])
    .controller('SigninController', SigninController);

  /** @ngInject */
  function SigninController($http, $state, $cookies, $rootScope, $filter,ENV) {
    var vm = this;
    // ________________________________________________________________________ public
    vm.formData = {};
    vm.year = new Date().getFullYear();

    $rootScope.permissionList = [];
    vm.formDataInfo = $cookies.getObject('userData');
    vm.login = login;
    activate();

    function activate() {

      if (angular.isDefined($cookies.get('userData')))
        $state.go('panel.dashboard');
    }

    function login() {
      vm.formData.password = CryptoJS.SHA1(vm.password).toString(); // eslint-disable-line
      vm.formData.mail = $filter('lowercase')(vm.formData.mail);
      $http.post(ENV.api.url  + 'PeopleResource.php?method=logIn', vm.formData, {
        headers: {
          'Authorization': 'Auth'
        }
      })
        .then(function (response) {
          $cookies.putObject('auth', {'Authorization': response.headers().authorization});
          $cookies.putObject('userData', response.data);
          $http.get(ENV.api.url  + 'PeopleResource.php?method=permission', {
            headers: $cookies.getObject('auth')
          })
            .then(function (data) {
              $cookies.putObject('Permissions', data.data);
              $rootScope.permissionList = data.data;
              $state.go('panel.dashboard');
            })
            .finally(function () {

            })

        }, function () {
          sweetAlert({title: "Nieprawidłowe hasło lub adres e-mail.", timer: 8000, icon: "error"}); // eslint-disable-line
          $cookies.remove('PHPSESSID');

        })
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('PasswController', PasswController);


  /** @ngInject */
  function PasswController($http, $cookies,ENV) {
    var vm = this;

    // ________________________________________________________________________ public
    vm.send = send;
    vm.year = new Date().getFullYear();
    vm.goodData = false;
    vm.badData = false;
    vm.msg = 'wprowadź dane';

    function send() {
      $http.post(ENV.api.url  + 'PeopleResource.php?method=remindPassword&mail=' + vm.formData.mail, null, {
        headers: $cookies.getObject('auth')
      })
        .then(function success() {
          sweetAlert({// eslint-disable-line
            title: "Sukces!",
            text: "Hasło zostało wysłane na adres e-mail podany podczas rejestracji.",
            timer: 8000,
            icon: "success"
          });

        }, function () {
          sweetAlert({title: "Błąd!", text: "Prosimy o kontakt z administracją.", timer: 8000, icon: "error"}); // eslint-disable-line

        })
    }
  }
})
();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('ActivationController', ActivationController);


  /** @ngInject */
  function ActivationController($stateParams, $http, $state,ENV) {
    var vm = this;
    vm.activ = activ;
    vm.correct = 0;
    activation();

    function activation() {
      vm.year = new Date().getFullYear();
      activ($stateParams.id, $stateParams.token);
    }

    function activ(id, token) {

      $http.post(ENV.api.url  + 'PeopleResource.php?method=activate&id=' + id + '&token=' + token)
        .then(function success() {
          vm.correct = 2;
          sweetAlert({// eslint-disable-line
              title: "Sukces!",
              text: "Konto zostało aktywowane, możesz przejść do logowania i w pełni korzystać z konta.",
              timer: 8000,
              icon: "success"
            }, function (isConfirm) {  // eslint-disable-line

              if (isConfirm) {
                $state.go('auth.signin');
              } else {
                $state.go('auth.signin');
              }
            }
          );
        }, function () {
          vm.correct = 1;
          sweetAlert({title: "Błąd!", text: "Prosimy o kontakt z administracją.", timer: 8000, icon: "error"}); // eslint-disable-line

        });
    }
  }
})
();


/*eslint-disable*/
(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .directive('ngSpinnerBar', ngSpinnerBar);

  /** @ngInject */
  function ngSpinnerBar($rootScope) {

    return {
      link: function (scope, element) {
        // by defult hide the spinner bar
        element.addClass('hide'); // hide spinner bar by default

        // display the spinner bar whenever the route changes(the content part started loading)
        $rootScope.$on('$stateChangeStart', function (event) {
          element.removeClass('hide'); // show spinner bar
          if (event.defaultPrevented) {
            element.addClass('hide'); // hide spinner bar
          }
        });

        // hide the spinner bar on rounte change success(after the content loaded)
        $rootScope.$on('$stateChangeSuccess', function () {
          element.addClass('hide'); // hide spinner bar
          $('body').removeClass('page-on-load'); // remove page loading indicator
          // Layout.setSidebarMenuActiveLink('match'); // activate selected link in the sidebar menu
        });

        // handle errors
        $rootScope.$on('$stateNotFound', function () {
          element.addClass('hide'); // hide spinner bar
        });

        // handle errors
        $rootScope.$on('$stateChangeError', function () {
          element.addClass('hide'); // hide spinner bar
        });
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .service('ngTableService', ngTableService);

  /* @ngInject */
  function ngTableService(NgTableParams, $filter) {
    var vm = this;

    vm.init = init;

    function init(obj, counts) {
      vm.list = [];
      vm.search = '';

      vm.table = new NgTableParams(obj || {page: 1, count: 10, sorting: {'id': 'asc'}}, {
        counts: counts || [5, 10, 20, 50],
        getData: function (params) {
          var filteredData = params.filter() ? $filter('filter')(vm.list, vm.search) : vm.list;
          var orderedData = params.sorting() ? $filter('orderBy')(filteredData, params.orderBy()) : filteredData;
          params.total(orderedData.length);

          if (orderedData.length > 0) {
            var lastPage = (1 + Math.floor((orderedData.length - 1) / params.count()));
            if (params.page() > lastPage) {
              params.page(lastPage);
            }
          } else if (params.page() !== 1) {
            params.page(1);
          }

          return orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
        }
      });

      return vm.table;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .service('ModalService', ModalService);

  /* @ngInject */
  function ModalService($uibModal, $templateRequest) {
    var vm = this;

    vm.form = form;
    vm.delete = del;

    function form(templateUrl, data, ctrl, size) {
      $templateRequest(templateUrl);

      var controller = ctrl || 'FormModalController';

      var modal = $uibModal.open({
        templateUrl: templateUrl,
        controller: controller,
        controllerAs: 'vm',
        size: size || 'lm',
        backdrop: 'static'
      });

      if (data) {
        modal.formData = angular.copy(data);
      }

      return modal;
    }

    function del(templateUrl) {
      $templateRequest(templateUrl);

      return $uibModal.open({
        templateUrl: templateUrl,
        controller: 'DeleteModalController as vm',
        size: 'sm'
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('FormModalController', FormModalController);

  /** @ngInject */
  function FormModalController($uibModalInstance) {
    var vm = this;

    vm.formData = [];

    vm.ok = ok;
    vm.cancel = cancel;

    activate();

    function activate() {
      vm.formData = $uibModalInstance.formData;
    }

    function ok() {
      $uibModalInstance.close(vm.formData);
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .directive('ngEnter', ngEnter);

  /** @ngInject */
  function ngEnter($document) {

    return {
      scope: {
        ngEnter: '&'
      },
      link: function (scope) {
        var enterWatcher = function (event) {
          if (event.which === 13) {
            scope.ngEnter();
            scope.$apply();
            event.preventDefault();
            $document.unbind('keydown keypress', enterWatcher);
          }
        };
        $document.bind('keydown keypress', enterWatcher);
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('DeleteModalController', DeleteModalController);

  /** @ngInject */
  function DeleteModalController($uibModalInstance) {
    var vm = this;

    vm.ok = ok;
    vm.cancel = cancel;

    function ok() {
      $uibModalInstance.close();
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .controller('AppController', AppController);

  /** @ngInject */
  function AppController(PermissionsService, $rootScope, $cookies) {
    $rootScope.permissionList = $cookies.getObject('Permissions');
    PermissionsService.setPermissions($rootScope.permissionList);
  }
})();

/**
 * Created by staz on 2016-08-24.
 */
(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .service('MainService', MainService);

  /** @ngInject */
  function MainService() {
    var vm = this;

    var data = [];

    vm.setData = setData;
    vm.getData = getData;

    function setData(index, name, value) {
      var obj = {
        name: name,
        value: value
      };
      data[index] = obj;
    }

    function getData(index, what_is_return) {
      if (what_is_return === 'value' && angular.isDefined(data[index]))
        return data[index].value;
      else if (what_is_return === 'name' && angular.isDefined(data[index]))
        return data[index].name;

      return 1;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .filter('propsFilter', propsFilter);

  function propsFilter() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop] && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();

(function () {
  'use strict';
  angular
    .module('payviasmsClient')
    .service('PermissionsService', PermissionsService);
  function PermissionsService($rootScope) {
    var permissionList;
    return {
      setPermissions: function (permissions) {

        permissionList = permissions;
       $rootScope.$broadcast('permissionsChanged');
      },
      hasPermission: function (permission) {
        permission = permission.trim();
        return _.some(permissionList, function (item) {
          if (_.isString(item)) {
            return item.trim() === permission
          }
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope,$state,PermissionsService,$cookies) {


    $rootScope.$state = $state;

    $rootScope.$on('headerClick', function () {// eslint-disable-line
      $rootScope.$broadcast('headerClick2');
    });
    $rootScope.$on('$stateChangeStart', function(event, toState){// eslint-disable-line
      var permission = toState.permission;
      var expireDate = new Date();
      expireDate.setSeconds(expireDate.getSeconds() + 1800);
      $cookies.putObject('userData',$cookies.getObject('userData'),{expires:expireDate});
      $cookies.putObject('auth',$cookies.getObject('auth'),{expires:expireDate});
      $cookies.putObject('Permissions',$cookies.getObject('Permissions'),{expires:expireDate});
      $cookies.putObject('hiddenInfo',$cookies.getObject('hiddenInfo'),{expires:expireDate});
      if (_.isString(permission) && !PermissionsService.hasPermission(permission)) {

        $state.go('error.Error401');
        event.preventDefault();

      }
    });

    $rootScope.$on('numberOfProduct', function () {// eslint-disable-line
      $rootScope.$broadcast('numberOfProduct2');
    });


    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig(stateHelperProvider, $urlRouterProvider) {

    $urlRouterProvider.otherwise('/auth/signin');

    stateHelperProvider

    /** LOGIN */
      .state({
        name: 'auth',
        views: {
          'master': {
            templateUrl: 'app/routes/auth/auth.view.html'
          }
        },
        children: []
      })
      /**Error*/
      .state({
        name: 'error',
        views: {
          'master': {
            templateUrl: 'app/routes/error/error.view.html'
          }
        },
        children: []
      })

      /** PANEL */
      .state({
        name: 'panel',
        views: {
          'master': {
            templateUrl: 'app/routes/panel/panel.view.html'
          },
          'header@panel': {
            templateUrl: 'app/routes/panel/_layout/header.html',
            controller: 'HeaderController as vm'
          },
          'footer@panel': {
            templateUrl: 'app/routes/panel/_layout/footer.html',
            controller: 'FooterController as vm'
          }
        },
        children: []
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .factory('settings', settings);

  /** @ngInject */
  function settings($rootScope) {
    var settings = {};

    $rootScope.settings = settings;

    return settings;
  }

})();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')

    .constant('AUTH', {
      authorised: 'authorised',
      notAuthorised: 'notAuthorised',
      loginRequired: 'loginRequired'
    })

})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .config(config);

  /** @ngInject */
  function config(ENV, $logProvider, RestangularProvider, cfpLoadingBarProvider, $httpProvider, $translateProvider) {
    Acces();
    $logProvider.debugEnabled(ENV.debug);

    // Restangular
    RestangularProvider.setBaseUrl(ENV.api.url);


    // Language
    $translateProvider.translations('pl', {
      'ACTION': 'Akcja',
      'CREATE': 'Stworzono',
      'UPDATE': 'Zaktualizowano',
      'DELETE': 'Usunięto',
      'PASSWORD': 'Hasło',
      'STATUS': 'Status',
      'LOGIN': 'Zalogowano',
      'ACTIVATION': 'Aktywowano',
      'ROLE': 'Rola',
      'ELEMENT': 'Element',
      'USER': 'Użytkownik',
      'FIRST NAME': "Imię",
      'LAST NAME': 'Nazwisko',
      'TELEPHONE NUMBER': 'Numer telefonu',
      'ADDRESS': 'Adres',
      'POSTAL CODE': 'Kod Pocztowy',
      'LOCATION': 'Lokalizacja',
      'BANK ACCOUNT NUMBER': 'Numer konta bankowego',
      'TYPE': 'Typ',
      'NAME IDENTIFICATION': 'Nazwa identyfikacyjna',
      'IDENTIFICATION': 'Identyfikator',
      'SPECIAL TYPE': 'Typ specjalny',
      'TAX OFFICE': 'Urząd Skarbowy',
      'PLACE': 'Województwo, powiat, gmina',
      'COMMISSION': 'Prowizja'
    });
    $translateProvider.preferredLanguage('pl');
    // Loading Bar
    cfpLoadingBarProvider.latencyThreshold = 500;

    function Acces() {

      $httpProvider.interceptors.push(function ($q, $injector) {
        return {
          /*        'response': function (response) {

                     if(response.data.Warning=="No data")
                      // sweetAlert({title:"Brak Danych",time:2000,icon:"error"}); // eslint-disable-line
                    Flash.create('danger','Brak Danych',2000);

                    return response;
                  },*/
          'responseError': function (rejection) {
            if (rejection.status === 401) {
              $injector.get('$state').transitionTo('error.Error401');
            }
            return $q.reject(rejection);
          }
        };
      });
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .directive('hasPermission', hasPermission);


  function hasPermission(PermissionsService) {
    return {
      link: function (scope, element, attrs) {
        if (!_.isString(attrs.hasPermission)) {
          throw 'hasPermission value must be a string'
        }
        var value = attrs.hasPermission.trim();
        var notPermissionFlag = value[0] === '!';
        if (notPermissionFlag) {
          value = value.slice(1).trim();
        }

        function toggleVisibilityBasedOnPermission() {
          var hasPermission = PermissionsService.hasPermission(value);
          if (hasPermission && !notPermissionFlag || !hasPermission && notPermissionFlag) {
            element.show();
          }
          else {
            element.hide();
          }
        }

        toggleVisibilityBasedOnPermission();
        scope.$on('permissionsChanged', toggleVisibilityBasedOnPermission);
      }
    }
  }
})();

(function () {
'use strict';

angular
.module('payviasmsClient')

.constant('ENV', {
	'name': 'master',
	'api': {
		'url': 'https://getpay.pl/panel/app/common/resource/'
	},
	'debug': false,
	'buildDate': '1608739142148',
	'version': '0.5.1'
})

;})();

(function () {
  'use strict';

  angular
    .module('payviasmsClient')
    .directive('adjustTimezone', adjustTimezone);


  function adjustTimezone($filter) {
    return {
      restrict: 'A',
      scope: {
        adjustTimezone: '@'
      },
      link: function ($scope, element, attrs) {
        var date = new Date(attrs.adjustTimezone);

        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        element.text($filter('date')(date, attrs.filter));
      }
    }
  }
})();

angular.module("payviasmsClient").run(["$templateCache", function($templateCache) {$templateCache.put("app/routes/auth/auth.view.html","<div class=main_container><div ui-view=content></div></div>");
$templateCache.put("app/routes/error/error.view.html","<div class=main_container><div ui-view=content></div></div>");
$templateCache.put("app/routes/panel/panel.view.html","<div class=main_container><div class=background-blue ui-view=header></div></div>");
$templateCache.put("app/routes/auth/activation/activation.index.html","<style>body {\r\n    background-color: #fff;\r\n  }</style><div><div class=login_wrapper><div class=\"animate form login_form\"><section class=login_content><form><div><h1>&nbsp; Aktywacja konta &nbsp;</h1></div><div class=separator><div ng-if=\"vm.correct==2\"><h3 class=\"count green\">Konto zostało aktywowane, możesz się zalogować i w pełni korzystać z konta.</h3></div><p class=change_link><a ui-sref=auth.signin class=to_register>Zaloguj się</a></p><div class=clearfix></div><br><div><h1>getpay.pl</h1><p>© {{vm.year}} GetPay. Wszelkie prawa zastrzeżone.</p></div></div></form></section></div></div></div>");
$templateCache.put("app/routes/auth/passw/passw.index.html","<style>body {\r\n    background-color: #fff;\r\n  }</style><div><div class=login_wrapper><div class=\"animate form login_form\"><section class=login_content><form><h1>Odzyskiwanie hasła</h1><p ng-show=vm.goodData style=\"border:3px; color:greenyellow; border-style:solid; border-color:darkgreen; padding: 1em\">{{vm.msg}}</p><p ng-show=vm.badData style=\"border:3px; color:red; border-style:solid; border-color:#FF0000; padding: 1em\">{{vm.msg}}</p><div class=form-group data-ng-class=\"{\'has-error\' : form.email.$invalid && !form.email.$pristine}\"><input type=email class=form-control placeholder=\"{{ \'Email\' | translate }}\" data-ng-model=vm.formData.mail name=firstName required></div><div><button class=\"btn btn-success\" data-ng-click=vm.send()>{{ \'Wyślij\' | translate }}</button></div><div class=clearfix></div><div class=separator><p class=change_link><a ui-sref=auth.signin class=to_register>Zaloguj się</a></p><div class=clearfix></div><br><div><h1>getpay.pl</h1><p>© {{vm.year}} GetPay. Wszelkie prawa zastrzeżone.</p></div></div></form></section></div></div></div>");
$templateCache.put("app/routes/auth/signin/signin.index.html","<style>body {\r\n    background-color: #fff;\r\n  }</style><div><div class=login_wrapper><div class=\"animate form login_form\"><section class=login_content><form><h1>Logowanie</h1><div class=form-group data-ng-class=\"{\'has-error\' : form.email.$invalid && !form.email.$pristine}\"><input type=email class=form-control placeholder=\"{{ \'Adres e-mail\' | translate }}\" data-ng-model=vm.formData.mail name=firstName required></div><div class=form-group data-ng-class=\"{\'has-error\' : form.password.$invalid && !form.password.$pristine}\"><input type=password class=form-control placeholder=\"{{ \'Hasło\' | translate }}\" data-ng-model=vm.password name=firstName required></div><div><button class=\"btn btn-success\" data-ng-click=vm.login()>{{ \'Zaloguj\' | translate }}</button></div><div class=clearfix></div><a class=reset_pass ui-sref=auth.passw>Nie pamiętasz hasła?</a><div class=separator><p class=change_link>Nie masz konta? <a ui-sref=auth.signup class=to_register>Zarejestruj się</a></p><div class=clearfix></div><br><div><h1>getpay.pl</h1><p>© {{vm.year}} GetPay. Wszelkie prawa zastrzeżone.</p></div></div></form></section></div></div></div>");
$templateCache.put("app/routes/auth/signup/signup.index.html","<style>body {\r\n    background-color: #fff;\r\n  }</style><div><div class=login_wrapper><div class=\"animate form login_form\"><section class=login_content><form name=form><h1>Rejestracja</h1><div class=form-group><md-input-container class=width-100><label>Typ Konta</label><md-select ng-model=vm.formData.type data-md-container-class=selectdemoSelectHeader md-on-close=vm.changeType()><md-optgroup label=\"Typ Konta\"><md-option ng-value=item.type ng-repeat=\"item in vm.filter \">{{item.type| SingUpType}}</md-option></md-optgroup></md-select></md-input-container><p data-ng-show=\"form.status.$invalid && !form.status.$pristine\" class=help-block>To pole jest wymagane.</p></div><div class=form-group data-ng-class=\"{\'has-error\' : form.name.$invalid && !form.name.$pristine}\"><input type=text class=form-control placeholder=\"{{ vm.placeholder.name }}\" data-ng-model=vm.formData.name name=name required></div><div class=form-group data-ng-class=\"{\'has-error\' : form.mail.$invalid && !form.mail.$pristine}\"><input type=email class=form-control placeholder=\"{{ \'Adres e-mail\' | translate }}\" data-ng-model=vm.formData.mail name=mail required></div><div class=form-group data-ng-class=\"{\'has-error\' : form.password.$invalid && !form.password.$pristine}\"><input type=password class=form-control placeholder=\"{{ \'Hasło\' | translate }}\" data-ng-model=vm.formData.password name=password required></div><div class=form-group data-ng-class=\"{\'has-error\' : form.address.$invalid && !form.address.$pristine}\"><input type=text class=form-control placeholder=\"{{ \'Adres (ulica, numer domu/mieszkania)\' | translate }}\" data-ng-model=vm.formData.address name=address required></div><div class=form-group data-ng-class=\"{\'has-error\' : form.postalCode.$invalid && !form.postalCode.$pristine}\"><input type=text class=form-control placeholder=\"{{ \'Kod pocztowy\' | translate }}\" data-ng-model=vm.formData.postalCode name=postalCode ng-model-options=\"{allowInvalid: true}\" pattern=\\d{2}-\\d{3} ng-change=vm.postPattern() minlength=6 maxlength=6 required></div><div class=form-group data-ng-class=\"{\'has-error\' : form.location.$invalid && !form.location.$pristine}\"><input type=text class=form-control placeholder=\"{{ \'Miejscowość\' | translate }}\" data-ng-model=vm.formData.location name=location required></div><div class=\"form-group animate-if\" ng-if=\"vm.formData.type==\'P\' \" data-ng-class=\"{\'has-error\' : form.identification.$invalid && !form.identification.$pristine}\"><input type=text class=form-control placeholder=\"{{ \'NIP\' | translate }}\" data-ng-model=vm.formData.identification name=identification ng-required=\"vm.formData.type==\'P\'\"></div><div class=form-group data-ng-class=\"{\'has-error\' : form.bankAccountNumber.$invalid && !form.bankAccountNumber.$pristine}\"><input type=text class=form-control placeholder=\"{{ \'Numer konta bankowego (bez spacji)\' | translate }}\" data-ng-model=vm.formData.bankAccountNumber maxlength=26 name=bankAccountNumber pattern=\\d{26} required></div><div class=form-group><label><input type=checkbox ng-model=vm.regulation required> Akceptuje <a href=https://getpay.pl/regulamin.pdf target=_blank>Regulamin</a></label></div><button nclick=\"return gtag_report_conversion(‘https://getpay.pl/panel/#!/auth/signin\')\" class=\"btn btn-success\" data-ng-click=vm.register() data-ng-disabled=\"form.$invalid || !vm.regulation || vm.block\">{{ \'Zarejestruj\' | translate }}</button><div class=clearfix></div><div class=separator><p class=change_link>Masz już konto? <a ui-sref=auth.signin class=to_register>Zaloguj się</a></p><div class=clearfix></div><br><div><h1>getpay.pl</h1><p>© {{vm.year}} GetPay. Wszelkie prawa zastrzeżone.</p></div><div id=hid>{{enableBtn()}}</div></div></form></section></div></div></div>");
$templateCache.put("app/routes/error/401/error401.index.html","<div class=\"container body\"><div class=main_container><!-- page content --><div class=col-md-12><div class=col-middle><div class=\"text-center text-center\"><h1 class=error-number>401</h1><h2>Brak dostępu do podanej strony</h2><p><a ng-click=vm.toLogin()>Przejdź do strony logowania</a></p></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/routes/panel/_layout/footer.html","<footer><div class=pull-right><strong>© {{ vm.year }} GetPay. Wszelkie prawa zastrzeżone</strong> | developed by <a href=http://nanocoder.pl target=_blank>nanocoder.pl</a></div><div class=clearfix></div></footer>");
$templateCache.put("app/routes/panel/_layout/header.html","<div class=\"col-md-3 left_col\" ng-class=\"{\'nav-collapsed\':vm.collapsed}\"><div class=\"left_col scroll-view\"><div ng-if=!vm.collapsed class=\"navbar nav_title\" style=\"border: 0; padding: 10px 3px\"><!--<a ng-click=\"vm.active = 0\" ui-sref=\"panel.dashboard\" class=\"site_title\">--> <img ng-click=\"vm.active = 0\" class=cursor-pointer style=\"max-width: 98%; height: auto\" ui-sref=panel.dashboard src=https://getpay.pl/panel/assets/images/logo.png alt=\"GetPay - Płatności SMS Premium Rate\"><!--</a>--></div><div class=clearfix></div><br><!-- sidebar menu --><div id=sidebar-menu class=\"main_menu_side hidden-print main_menu\"><div class=menu_section><ul class=\"nav side-menu\"><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/dashboard\') > -1 }\"><a has-permission=sms.create ui-sref=panel.dashboard><i class=\"glyphicon glyphicon-signal\"></i>&nbsp; &nbsp; Pulpit</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/profile\') > -1 }\"><a has-permission=people.view ui-sref=panel.clientProfile><i class=\"fa fa-user\"></i> Profil</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/services\') > -1 }\"><a has-permission=service.view ui-sref=panel.clientServices><i class=\"fa fa-cogs\"></i> Usługi</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/settlements\') > -1 }\"><a has-permission=realization.view ui-sref=panel.clientSettlements><i class=\"fa fa-usd\"></i> Rozliczenia</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/history\') > -1 }\"><a has-permission=sms.view ui-sref=panel.clientHistory><i class=\"fa fa-history\"></i> Historia</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/api\') > -1 }\"><a has-permission=people.view ui-sref=panel.clientApi><i class=\"fa fa-file\"></i> API</a></li><!--ADMIN--><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/dashboard\') > -1 }\"><a has-permission=people.viewAll ui-sref=panel.dashboard><i class=\"glyphicon glyphicon-signal\"></i>&nbsp; &nbsp; Pulpit</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/profile\') > -1 }\"><a has-permission=people.viewAll ui-sref=panel.profileAdmin><i class=\"fa fa-user\"></i> Profil</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/clients\') > -1 }\"><a has-permission=people.viewAll ui-sref=panel.adminClients><i class=\"fa fa-users\"></i> Klienci</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/services\') > -1 }\"><a has-permission=service.viewAll ui-sref=panel.adminServices><i class=\"fa fa-cogs\"></i> Usługi</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/settlements\') > -1 }\"><a has-permission=realization.viewAll ui-sref=panel.adminSettlements><i class=\"fa fa-usd\"></i> Rozliczenia</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/history\') > -1 }\"><a has-permission=sms.viewAll ui-sref=panel.adminHistory><i class=\"fa fa-history\"></i> Historia</a></li><li ng-class=\"{ \'active\' : ($state.current.url).search(\'/eventLog\') > -1 }\"><a has-permission=sms.createAll ui-sref=panel.clientEventLog><i class=\"fa fa-book\"></i> Dziennik zdarzeń</a></li></ul></div></div><!-- /sidebar menu --><!-- /menu footer buttons --><!-- /menu footer buttons --><div class=\"sidebar-footer hidden-small\"><a data-ng-disabled=disabled data-toggle=\"\" data-placement=top><span></span></a></div></div></div><div class=top_nav ng-class=\"{\'margin-collapsed\':vm.collapsed}\"><div class=nav_menu><div class=\"alert alert-info alert-dismissible fade in\" role=alert ng-show=vm.show style=margin:0><button type=button class=close data-dismiss=alert aria-label=Close ng-click=app.setHidden()><span aria-hidden=true>&times;</span></button> Twoje konto jest ograniczone, nie możesz zlecać dyspozycji wypłaty. Prosimy o wykonanie przelewu weryfikującego Twoje dane, aby znieść ograniczenie. Więcej informacji w \"Rozliczeniach\".</div><nav role=navigation><div class=\"nav toggle\"><a ng-click=\"vm.collapsed = !vm.collapsed\" id=menu_toggle><i class=\"fa fa-bars\"></i></a></div><ul class=\"nav navbar-nav navbar-right\"><li><a style=\"min-width: 170px\" class=\"user-profile dropdown-toggle cursor-pointer\" data-toggle=dropdown aria-expanded=true><i class=\"fa fa-user\" style=\"margin-right: 6px\"></i> {{vm.formDataInfo.name}} <span class=\"fa fa-angle-down\"></span></a><ul class=\"dropdown-menu dropdown-usermenu pull-right\"><li has-permission=people.view ng-click=\"vm.active = 1\"><a ui-sref=panel.clientProfile>Profil</a></li><li has-permission=people.viewAll ng-click=\"vm.active = 16\"><a ui-sref=panel.profileAdmin>Profil</a></li><li><a data-ng-click=vm.logOut()><i class=\"fa fa-sign-out pull-right\"></i> Wyloguj</a></li></ul></li></ul></nav></div></div><div class=right_col role=main ng-class=\"{\'margin-collapsed\':vm.collapsed}\"><div ui-view=content></div><div ui-view=footer></div></div>");
$templateCache.put("app/routes/panel/admin/clients/clients.delete.html","<div class=modal-header><h3 class=modal-title>Edycja</h3></div><div class=modal-body><form class=form-row-seperated name=form><div class=\"row text-center\">Jesteś pewny że chcesz usunąć tego klienta?<br><br><button class=\"btn btn-primary\" data-ng-click=vm.ok()>Usuń</button> <button class=\"btn btn-warning\" data-ng-click=vm.cancel()>Zamknij</button></div></form></div>");
$templateCache.put("app/routes/panel/admin/clients/clients.edit.html","<div class=modal-header><h3 class=modal-title>Edycja</h3></div><div class=modal-body><div class=col-xs-12><div class=\"row data-presentation\" ng-if=\"vm.formData.type != null\"><div class=\"col-xs-4 text-right data-label\">Typ:</div><div class=\"col-xs-8 data-details\"><span ng-if=\"vm.formData.type == \'P\'\">Konto Firmowe </span><span ng-if=\"vm.formData.type == \'F\'\">Konto Prywatne</span></div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Nazwa:</div><div class=\"col-xs-8 data-details\">{{vm.formData.name}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Adres:</div><div class=\"col-xs-8 data-details\">{{vm.formData.address}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Kod pocztowy i miejscowość:</div><div class=\"col-xs-8 data-details\">{{vm.formData.postalCode}} {{vm.formData.location}}</div></div><div class=\"row data-presentation\" ng-if=\"vm.formData.identification != null\"><div class=\"col-xs-4 text-right data-label\"><span ng-if=\"vm.formData.type == \'F\'\">PESEL: </span><span ng-if=\"vm.formData.type == \'P\'\">NIP:</span></div><div class=\"col-xs-8 data-details\">{{vm.formData.identification}}</div></div><div class=\"row data-presentation\" ng-if=\"vm.formData.bankAccountNumber != null\"><div class=\"col-xs-4 text-right data-label\">Numer konta bankowego:</div><div class=\"col-xs-8 data-details\">{{vm.formData.bankAccountNumber}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Email:</div><div class=\"col-xs-8 data-details\">{{vm.formData.mail}}</div></div><div class=\"row data-presentation\" ng-if=\"vm.formData.apiKey != null\"><div class=\"col-xs-4 text-right data-label\">Klucz API:</div><div class=\"col-xs-8 data-details\">{{vm.formData.apiKey}}</div></div></div><div class=form-group data-ng-class=\"{\'has-error\' : form.commission.$invalid && !form.commission.$pristine}\"><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Prowizja:</div><div class=\"col-xs-8 data-details\"><div class=\"col-xs-11 data-details\"><input type=number name=commission class=form-control ng-model=vm.formDataToString.commission ng-change=vm.change() title=commission></div><h4>%</h4></div></div></div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Status:</div><div class=\"col-xs-8 data-details\"><md-input-container class=width-100><label>Status</label><md-select ng-model=vm.formData.status data-md-container-class=selectdemoSelectHeader><md-optgroup label=Status><md-option ng-value=item.status ng-repeat=\"item in vm.statusList\"><span ng-if=\"item.status == \'A\'\">Aktywny</span> <span ng-if=\"item.status == \'N\'\">Nieaktywny</span></md-option></md-optgroup></md-select></md-input-container><p data-ng-show=\"form.status.$invalid && !form.status.$pristine\" class=help-block>To pole jest wymagane.</p></div></div><div class=clearfix></div><div class=modal-footer><button class=\"btn btn-primary pull-right\" data-ng-click=vm.ok() data-ng-disabled=form.$invalid>Zapisz</button> <button class=\"btn btn-warning pull-right\" data-ng-click=vm.cancel()>Anuluj</button></div>");
$templateCache.put("app/routes/panel/admin/clients/clients.index.html","<div class=col-xs-12><div class=title_left><h3>Klienci</h3></div></div><div class=clearfix></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=\"x_content overflow-x\"><div class=\"table-responsive col-xs-12\"><table ng-table=vm.tableParams class=\"table table-striped table-bordered table-hover jambo_table\"><tr ng-repeat=\"row in $data | filter:vm.search\"><td filter=\"{ name: \'text\'}\" data-title=\"\'Klient\'\" sortable>[{{row.id}}] {{row.name}}</td><td data-title=\"\'Weryfikacja płatności\'\" sortable>{{row.financeStatus | FinanceStatus }} <button has-permission=people.updateAll ng-click=vm.verify(row) class=\"btn btn-default btn-xs\"><i class=\"fa fa-edit\"></i></button></td><td data-title=\"\'Status aktywacji\'\" sortable><span ng-if=\"row.status == \'A\'\">Aktywny</span> <span ng-if=\"row.status == \'N\'\">Nieaktywny</span></td><td class=\"text-center wide-column\" data-title=\"\'Opcje\'\"><button has-permission=people.updateAll ng-click=vm.edit(row) class=\"btn btn-warning\">Szczegóły</button> <button ng-click=vm.dele(row) has-permission=people.deleteAll class=\"btn btn-danger\">Usuń</button></td></tr></table></div></div></div></div></div>");
$templateCache.put("app/routes/panel/admin/clients/clients.verify.html","<div class=modal-header><h3 class=modal-title>Weryfikacja</h3></div><div class=modal-body><form class=form-row-seperated name=form><div class=\"row text-center\"><div class=\"form-group col-xs-12\"><label class=control-label>Status</label><md-input-container class=width-100><label>Status</label><md-select ng-model=vm.formData.status data-md-container-class=selectdemoSelectHeader><md-optgroup label=Status><md-option ng-value=item.status ng-repeat=\"item in vm.status \">{{item.status| FinanceStatus}}</md-option></md-optgroup></md-select></md-input-container><div class=margin-top-10><button class=\"btn btn-success\" data-ng-click=vm.ok(vm.formData.status) ng-disabled=vm.loading>Zapisz</button> <button class=\"btn btn-warning\" data-ng-click=vm.cancel()>Zamknij</button></div></div></div></form></div>");
$templateCache.put("app/routes/panel/admin/eventLog/eventLog.index.html","<div><div class=col-xs-12><div class=title></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Dziennik zdarzeń <small>Historia konta</small></h2><div class=clearfix></div></div><div class=col-xs-12><div class=col-xs-9><div class=form-group><label>Nazwa użytkownika</label><md-input-container class=width-100><label>Wybierz użytkownika</label><md-select ng-model=vm.form.peopleId name=pplSelect id=pplSelect data-md-container-class=selectdemoSelectHeader><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Użytkownik><md-option ng-click=vm.getServices() ng-value=item.id ng-repeat=\"item in vm.people | filter: vm.searchInput\">[{{item.id}}] {{item.name}}</md-option></md-optgroup></md-select></md-input-container></div></div><div class=form-group><button class=\"btn btn-info btn-lg pull-right margin-top-10\" ng-click=vm.getAll(vm.form.peopleId)>Szukaj</button></div></div><div class=\"margin-top-15 col-xs-12\"><table ng-table=vm.tableParams class=\"table table-striped table-bordered table-hover jambo_table\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'Data\'\" sortable><span>{{row.date | date: \'dd.MM.yyyy HH:mm\'}}</span></td><td data-title=\"\'Akcja\' \" sortable>{{row.action | translate}}, {{row.element | eventLog }}</td></tr></table></div></div></div></div></div><div class=clearfix></div></div>");
$templateCache.put("app/routes/panel/admin/history/history.index.html","<div class=col-xs-12><div class=title><h3>Historia</h3></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Transakcje <small>Historia wszystkich transakcji</small></h2><div class=clearfix></div></div><form><div class=\"x_content overflow-x\"><div class=col-xs-12><div class=row><div class=\"form-group col-xs-12 col-sm-6\"><label>Data od</label><div class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} ng-model=vm.formData.dateFrom is-open=vm.openCalStart datepicker-options=dateOptions ng-required=true close-text=Close alt-input-formats=altInputFormats title=\"Data od\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.open()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Data do</label><div class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} ng-model=vm.formData.dateTo is-open=vm.openCalEnd datepicker-options=dateOptions ng-required=true close-text=Close alt-input-formats=altInputFormats title=\"Data do\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.open1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=row><div class=\"form-group col-xs-12 col-sm-6\"><label>Nazwa użytkownika</label><md-input-container class=width-100><label>Wybierz uzytkownika</label><md-select ng-model=vm.form.peopleId data-md-container-class=selectdemoSelectHeader><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Użytkownicy><md-option ng-value=item ng-click=\"vm.getServices(item);vm.point=false\" ng-repeat=\"item in vm.people | filter: vm.searchInput\">[{{item.id}}] {{item.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Numery Premium</label><md-input-container class=width-100><label>Wybierz numery</label><md-select ng-model=vm.form.numIds data-md-container-class=selectdemoSelectHeader multiple><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Numery><md-option ng-value=item ng-repeat=\"item in vm.numList | filter: vm.searchInput\">{{item.number}}</md-option></md-optgroup></md-select></md-input-container></div></div><div class=row><div class=\"form-group col-xs-12 col-sm-6\"><label>Usługa</label><md-input-container class=width-100><label>Wybierz usługi</label><md-select ng-model=vm.form.serviceIdList data-md-container-class=selectdemoSelectHeader multiple><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Usługa><md-option ng-value=item ng-repeat=\"item in vm.service | filter: vm.searchInput\">{{item.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Kod</label><input type=text class=form-control ng-model=vm.formData.code title=Kod></div></div><div class=row><div class=\"form-group col-xs-12 col-sm-6\"><label>Numer telefonu</label><input type=number min=10000000 max=9999999999999 class=\"form-control phone\" ng-model=vm.formData.telephoneNumber title=Numer></div><div class=\"form-group col-xs-12 col-sm-6\"><label>Status</label><md-input-container class=width-100><label>Status</label><md-select ng-model=vm.formData.status data-md-container-class=selectdemoSelectHeader><md-optgroup label=Status><md-option ng-selected=\"item.status == null\" ng-value=item.status ng-repeat=\"item in vm.statusList\"><span ng-if=\"item.status == null\">Brak filtru</span> <span ng-if=\"item.status == true\">Wykorzystany</span> <span ng-if=\"item.status == false\">Niewykorzystany</span></md-option></md-optgroup></md-select></md-input-container></div></div></div></div></form><div class=col-xs-12><button class=\"pull-right btn btn-default\" ng-click=vm.getHistory()>Szukaj</button> <button class=\"pull-right btn btn-default\" ng-click=vm.sort()>Najczęstsze</button></div><div class=\"margin-top-15 col-xs-12\" ng-if=\"vm.history.length>0\"><div style=\"overflow-y:auto; overflow-x: auto\"><table ng-table=vm.tableParams style=\"min-width: 600px\" class=\"table table-striped table-bordered table-hover jambo_table\"><tr align=center valign=center ng-repeat=\"row in $data\"><td data-title=\"\'Nazwa usługi\'\" sortable>{{row.name}}</td><td data-title=\"\'Treść SMS\'\" sortable>{{row.content}}</td><td data-title=\"\'Numer premium\'\" sortable>{{row.number}}</td><td data-title=\"\'Kod zwrotny\'\" sortable>{{row.code}}</td><td data-title=\"\'Status kodu\'\" sortable><span ng-if=\"row.status==true\">Wykorzystany</span> <span ng-if=\"row.status==false\">Niewykorzystany</span></td><td data-title=\"\'Numer nadawcy\'\" style=\"min-width: 130px\" sortable>{{row.telephoneNumber.substring(0,3)}} {{row.telephoneNumber.substring(3,6)}} {{row.telephoneNumber.substring(6,9)}} {{row.telephoneNumber.substring(9)}}</td><td data-title=\"\'Prowizja\'\" sortable>{{row.amount}}</td><td data-title=\"\'Data realizacji\'\" style=\"min-width: 100px\" sortable>{{row.sendDate | date:\"dd.MM.yyyy HH:mm\" }}</td></tr></table></div></div></div><div class=clearfix></div></div><div class=clearfix></div></div></div>");
$templateCache.put("app/routes/panel/admin/profile/profile.index.html","<div><div><div class=col-xs-12><div class=title><h3 class=pull-left>Profil</h3></div></div></div><div class=row></div><ul class=\"nav nav-tabs bar_tabs profile-tab dflex\" role=tablist><li role=presentation class=\"active cursor-pointer text-no-wrap\"><a data-target=#client id=client-info role=tab data-toggle=tab aria-expanded=true>Dane użytkownika</a></li></ul><div class=\"tab-content profile-tab-content\"><div role=tabpanel class=\"tab-pane fade active in\" id=client aria-labelledby=home-tab><div class=\"col-xs-12 col-sm-6 col-sm-offset-3\"><div class=text-center><h3>{{vm.formDataInfo.name}}</h3></div><div class=profile-info><ul class=\"list-unstyled user_data\"><li><i class=\"fa fa-map-marker user-profile-icon\"></i> {{vm.formDataInfo.address}}, {{vm.formDataInfo.postalCode}} {{vm.formDataInfo.location}}</li><li class=m-top-xs><i class=\"fa fa-external-link user-profile-icon\"></i> {{vm.formDataInfo.mail}}</li></ul></div><h4>Zmień hasło:</h4><form class=\"form-horizontal form-label-left\"><div class=form-group><div class=\"col-xs-12 no-padding\"><input type=password class=form-control placeholder=\"Stare hasło\" data-ng-model=vm.oldPassword name=oldPassword></div></div><div class=form-group><div class=form-group><div class=\"col-xs-12 no-padding\"><input type=password class=form-control placeholder=\"Nowe haslo\" data-ng-model=vm.passwd name=passwd></div></div><div class=form-group><div class=\"col-xs-12 no-padding\"><input type=password class=form-control placeholder=\"Potwierdź haslo\" data-ng-model=vm.checkpasswd name=checkpasswd></div></div><button ng-click=vm.changePassword() ng-disabled=\"(vm.passwd!=vm.checkpasswd) || (vm.passwd==\'\')\" class=\"btn btn-info pull-right btn-no-margin-right\">Zmień hasło</button></div></form></div></div></div></div>");
$templateCache.put("app/routes/panel/admin/services/services.control.html","<div class=modal-header><h3 class=modal-title style=\"margin: 5px\">Kontrola</h3></div><div class=modal-body><form class=form-row-seperated name=form><div class=form-group data-ng-class=\"{\'has-error\' : form.status.$invalid && !form.status.$pristine}\"><label class=\"col-md-3 control-label\">{{ \'Aktywuj\' | translate }}</label><div class=col-md-8><switch name=enabled ng-model=vm.status on=\"{{\'Tak\' | translate}}\" off=\"{{\'Nie\' | translate}}\" class=green></switch></div></div><div class=form-group data-ng-class=\"{\'has-error\' : form2.description.$invalid && !form2.description.$pristine}\"><label class=\"col-xs-12 control-label\">{{ \'Komentarz\' | translate }}</label><div class=col-xs-12><textarea style=\"max-width: 530px\" class=form-control placeholder=\"{{ \'Komentarz\' | translate }}\" data-ng-model=vm.formData.response name=response required>\r\n            </textarea></div></div></form></div><div class=modal-footer><button class=\"btn btn-warning pull-right\" data-ng-click=vm.cancel()>Zamknij</button></div>");
$templateCache.put("app/routes/panel/admin/services/services.delete.html","<div class=modal-header><h3 class=modal-title>Edycja</h3></div><div class=modal-body><form class=form-row-seperated name=form><div class=row><div class=\"col-xs-12 text-center\">{{\'Jesteś pewny że chcesz usunąć tę usługę\' | translate}}?<br><br><button class=\"btn btn-primary\" data-ng-click=vm.ok()>Usuń</button> <button class=\"btn btn-warning\" data-ng-click=vm.cancel()>Anuluj</button></div></div></form></div>");
$templateCache.put("app/routes/panel/admin/services/services.edit.html","<div class=modal-header><h3 class=modal-title>Szczegóły</h3></div><div class=modal-body><div class=row></div><ul class=\"nav nav-tabs bar_tabs profile-tab\" role=tablist><li role=presentation class=\"active cursor-pointer\"><a data-target=#data id=client-info role=tab data-toggle=tab aria-expanded=true>Dane usługi</a></li><li role=presentation class=cursor-pointer><a data-target=#sms role=tab id=client-edit data-toggle=tab aria-expanded=false>SMS</a></li></ul><div class=\"tab-content profile-tab-content\"><div role=tabpanel class=\"tab-pane fade active in\" id=data aria-labelledby=home-tab><!-- DANE USŁUGI --><div class=col-xs-12><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Sekretny klucz API:</div><div class=\"col-xs-8 data-details\"><span ng-if=\"vm.dane.apiSecret != null\">{{vm.dane.apiSecret}} </span><span ng-if=\"vm.dane.apiSecret == null\">Brak numeru</span></div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">ID:</div><div class=\"col-xs-8 data-details\">{{vm.dane.id}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Nazwa:</div><div class=\"col-xs-8 data-details\">{{vm.dane.name}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Treść SMS:</div><div class=\"col-xs-8 data-details\">{{vm.dane.prefix}}.{{vm.dane.content}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Opis:</div><div class=\"col-xs-8 data-details\">{{vm.dane.description}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Strony WWW:</div><div class=\"col-xs-8 data-details\"><span ng-if=\"vm.dane.www.length == 0\">Brak stron WWW </span><span ng-if=\"vm.dane.www.length > 0\"><ul><li ng-repeat=\"www in vm.dane.www\">{{www}}</li></ul></span></div></div></div></div><div role=tabpanel class=\"tab-pane fade in\" id=sms aria-labelledby=home-tab><!-- SMS --><div class=col-xs-12><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Klasyfikacja:</div><div class=\"col-xs-8 data-details\"><span ng-if=\"vm.dane.classification == \'t\'\">+18 </span><span ng-if=\"vm.dane.classification == \'f\'\">Zwykła</span></div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Numery SMS:</div><div class=\"col-xs-8 data-details\"><span ng-if=\"vm.dane.numbers.length == 0\">Brak numerów</span><div ng-if=\"vm.dane.numbers.length > 0\"><ul><li ng-repeat=\"num in vm.dane.numbers\">{{num}}</li></ul></div></div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Treść SMS zwrotnego:</div><div class=\"col-xs-8 data-details\"><span>{{vm.dane.responseContent}}</span></div></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-warning pull-right\" data-ng-click=vm.cancel()>Zamknij</button></div>");
$templateCache.put("app/routes/panel/admin/services/services.index.html","<div class=col-xs-12><div class=title_left><h3>Usługi</h3></div></div><div class=clearfix></div><div class=row has-permission=service.viewAll><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=\"x_content overflow-x\"><div class=table-responsive><table ng-table=vm.tableParams class=\"table table-striped table-bordered table-hover jambo_table thead-no-wrap\"><tr ng-repeat=\"row in $data | filter : vm.search\"><td data-title=\"\'Klient\'\" sortable>[{{row.peopleId}}] {{row.peopleName}}</td><td data-title=\"\'Usługa\'\" sortable>{{row.prefix}}.{{row.content}} <button ng-click=vm.updatePrefix(row) class=\"btn btn-default btn-xs\"><i class=\"fa fa-edit\"></i></button></td><td data-title=\"\'Status usługi\'\" sortable><span ng-show=\"row.status==\'A\'\">Aktywny</span> <span ng-show=\"row.status==\'N\'\">Nieaktywny</span></td><td class=\"text-center wide-column\" data-title=\"\'Opcje\'\"><button ng-if=\"(row.status==\'N\')\" ng-click=vm.acti(row) class=\"btn btn-success\">Aktywuj</button> <button ng-if=\"(row.status==\'A\')\" ng-click=vm.deActi(row) class=\"btn btn-info\">Dezaktywuj</button> <button ng-click=vm.details(row.id) class=\"btn btn-warning\">Szczegóły</button> <button ng-click=vm.dele(row) class=\"btn btn-danger\">Usuń</button></td></tr></table></div></div></div></div></div><div class=col-xs-12><div class=title><h3>Generowanie testowych SMS\'ów</h3></div><div ng-show=\"vm.generateSucces==\'created\'\" class=\"alert alert-success alert-dismissible fade in\" role=alert><button class=close ng-click=\"vm.generateSucces=\'dontShow\'\"><span aria-hidden=true>×</span></button> <strong>Stworzono</strong> testowego SMS\'a Numer: {{vm.temp.telephoneNumber}} Kod: {{ vm.temp.code}}</div><div ng-show=\"vm.generateSucces==\'notCreated\'\" class=\"alert alert-danger alert-dismissible fade in\" role=alert><button class=close ng-click=\"vm.generateSucces=\'dontShow\'\"><span aria-hidden=true>×</span></button> <strong>Nie Udało się</strong> Stworzyć SMS\'a testowego.</div><div class=row><div class=col-xs-12><div class=x_panel><div class=x_title><h2>Wygeneruj testowe SMS\'y</h2><div class=clearfix></div></div><form name=formGenerate><div class=\"form-group col-xs-12 col-md-6\"><label>Nazwa użytkownika</label><md-input-container class=width-100><label>Wybierz użytkownika</label><md-select ng-model=vm.form.peopleIdFG data-md-container-class=selectdemoSelectHeader><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Użytkownik><md-option ng-click=vm.getServicesForGenerator(item) ng-value=item ng-repeat=\"item in vm.people | filter: vm.searchInput\">[{{item.id}}] {{item.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"form-group col-xs-12 col-md-6\"><label>Usługa</label><md-input-container class=width-100><label>Wybierz usługę</label><md-select ng-model=vm.form.serviceIdListFG data-md-container-class=selectdemoSelectHeader><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Usługa><md-option ng-click=\"vm.searched=false ;vm.getNumbersForService(item.id);vm.disableGenerator()\" ng-value=item ng-repeat=\"item in vm.serviceForGenerator | filter: vm.searchInput\">[{{item.id}}] {{item.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"form-group col-xs-12 col-md-6\" ng-show=vm.numshow><label>Numery Premium</label><md-input-container class=width-100><label>Wybierz numer</label><md-select ng-model=vm.form.numIdsFG data-md-container-class=selectdemoSelectHeader><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Numer><md-option ng-click=vm.disableGenerator(item) ng-value=item ng-repeat=\"item in vm.formGenerator.numbers | filter: vm.searchInput\">{{item.number}}</md-option></md-optgroup></md-select></md-input-container></div></form><div class=col-xs-12><button class=\"btn btn-success pull-right\" data-ng-disabled=vm.blockGenerator||vm.block ng-click=vm.generateSMS()>Generuj</button></div></div></div></div></div>");
$templateCache.put("app/routes/panel/admin/services/services.updatePrefix.html","<div class=modal-header><h3 class=modal-title>Edytuj</h3></div><div class=modal-body><form class=form-row-seperated name=form><div class=form-group data-ng-class=\"{\'has-error\' : form.prefix.$invalid && !form.prefix.$pristine}\"><label class=\"col-md-3 control-label\" style=\"margin-top: 5px\">Prefix</label><input type=text maxlength=4 class=form-control ng-model=vm.formData.prefix title=Prefix></div></form></div><div class=modal-footer><button class=\"btn btn-primary pull-right\" data-ng-click=vm.ok() data-ng-disabled=vm.disabled>Zapisz</button> <button class=\"btn btn-warning pull-right\" data-ng-click=vm.cancel()>Anuluj</button></div>");
$templateCache.put("app/routes/panel/admin/settlements/settlements.add.html","<div class=modal-header><h3 class=modal-title>Dodaj</h3></div><div ng-if=vm.check class=\"alert alert-warning alert-dismissible fade in\" role=alert><button type=button class=close ng-click=\"vm.check=false\"><span aria-hidden=true>×</span></button> <strong>Wartość</strong> nie może byc większa niż stan konta danego użytokwnika, oraz musi być większa od 100</div><div class=modal-body><form class=form-row-seperated name=form><label class=\"col-md-3 control-label\">Stan Konta</label><input type=text class=form-control ng-model=vm.indexData.accountBalance disabled title=\"Stan konta\"><div class=form-group data-ng-class=\"{\'has-error\' : form.value.$invalid && !form.value.$pristine}\"><label class=\"col-md-3 control-label\" style=\"margin-top: 5px\">Wartość</label><input type=number class=form-control ng-model=vm.formData.value ng-change=vm.checkInput() title=Wartość></div></form></div><div class=modal-footer><button class=\"btn btn-primary pull-right\" data-ng-click=vm.ok() data-ng-disabled=vm.disabled>Dodaj</button> <button class=\"btn btn-warning pull-right\" data-ng-click=vm.cancel()>Anuluj</button></div>");
$templateCache.put("app/routes/panel/admin/settlements/settlements.delete.html","<div class=modal-header><h3 class=modal-title>Edycja</h3></div><div class=modal-body><form class=form-row-seperated name=form><div class=\"row text-center\">Jesteś pewny że chcesz usunąć tę usługę?<br><br><button class=\"btn btn-primary\" data-ng-click=vm.ok()>Usuń</button> <button class=\"btn btn-warning\" data-ng-click=vm.cancel()>Zamknij</button></div></form></div>");
$templateCache.put("app/routes/panel/admin/settlements/settlements.edit.html","<div class=modal-header><h3 class=modal-title>Edytuj</h3></div><div ng-if=vm.check class=\"alert alert-warning alert-dismissible fade in\" role=alert><button type=button class=close ng-click=\"vm.check=false\"><span aria-hidden=true>×</span></button> <strong>Wartość</strong> nie może byc większa niż stan konta danego użytokwnika, oraz musi być większa od 0</div><div class=modal-body><form class=form-row-seperated name=form><label class=\"col-md-3 control-label\">Stan Konta</label><input class=form-control type=number ng-model=vm.indexData.accountBalance disabled title=\"Stan konta\"><div class=form-group data-ng-class=\"{\'has-error\' : form.value.$invalid && !form.value.$pristine}\"><label class=\"col-md-3 control-label\" style=\"margin-top: 5px\">Wartość</label><input type=number class=form-control ng-model=vm.formData.value ng-change=vm.checkInput() title=Wartość></div></form></div><div class=modal-footer><button class=\"btn btn-primary pull-right\" data-ng-click=vm.ok() data-ng-disabled=vm.disabled>Zapisz</button> <button class=\"btn btn-warning pull-right\" data-ng-click=vm.cancel()>Anuluj</button></div>");
$templateCache.put("app/routes/panel/admin/settlements/settlements.editStatus.html","<div class=modal-header><h3 class=modal-title>Edycja</h3></div><div class=modal-body><form class=form-row-seperated name=form><div class=\"row text-center\"><div class=\"form-group col-xs-12\"><label class=control-label>Typ Konta</label><md-input-container class=width-100><label>Status</label><md-select ng-model=vm.formData.status data-md-container-class=selectdemoSelectHeader md-on-close=vm.changeType()><md-optgroup label=Status><md-option ng-value=item.status ng-repeat=\"item in vm.status \">{{item.status| SettlementsStatus}}</md-option></md-optgroup></md-select></md-input-container><div class=margin-top-10><button class=\"btn btn-success\" data-ng-click=vm.ok(vm.formData.status) ng-disabled=vm.loading>OK</button> <button class=\"btn btn-warning\" data-ng-click=vm.cancel()>Anuluj</button></div></div></div></form></div>");
$templateCache.put("app/routes/panel/admin/settlements/settlements.index.html","<div class=col-xs-12 has-permission=realization.viewAll><div class=title><h3>Rozliczenia i Finanse</h3></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><form><div class=col-xs-6><div class=form-group><label>Nazwa klienta</label><md-input-container class=width-100><label>Wybierz klienta</label><md-select ng-model=vm.form.peopleId name=pplSelect id=pplSelect data-md-container-class=selectdemoSelectHeader><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Użytkownik><md-option ng-click=vm.getServices() ng-value=item ng-repeat=\"item in vm.people | filter: vm.searchInput\">[{{item.id}}] {{item.name}}</md-option></md-optgroup></md-select></md-input-container></div></div></form><div class=col-xs-12><button class=\"btn btn-info\" ng-click=vm.search(vm.form.peopleId)>Szukaj</button><div ng-if=vm.searched><div ng-if=vm.searched><div><h2 ng-show=vm.gotPeople>Stan konta klienta: <span ng-if=\"vm.formDataFinance.accountBalance == null\"><b>{{ 0 | customNumber}}</b></span> <b>{{vm.formDataFinance.accountBalance | customNumber}}</b> zł</h2></div><hr><h2 class=pull-left>Rozliczenia</h2></div><div class=\"margin-top-15 col-xs-12 no-padding\" ng-if=\"vm.formDataRealization.length>0\"><div class=table-responsive><table ng-table=vm.tableParams class=\"table table-striped table-bordered table-hover jambo_table\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'Nazwa klienta\'\" sortable>{{\'[\'+row.peopleId+\'] \'+row.peopleName}}</td><td data-title=\"\'Suma prowizji\'\" sortable>{{row.value | customNumber}} zł</td><td data-title=\"\'Status wypłaty\'\" sortable>{{row.status | SettlementsStatus}}</td><td data-title=\"\'Data realizacji\'\" sortable><span ng-show=\"row.realizationDate && row.realizationDate != \'Z\'\">{{row.realizationDate | date:\"dd.MM.yyyy HH:mm\"}} </span><span ng-hide=\"row.realizationDate && row.realizationDate != \'Z\'\">-</span></td><td data-title=\"\'Opcje\'\" class=text-center><span has-permission=realization.update><button class=\"btn btn-primary\" ng-click=\"vm.editStatus(row.id,row.status, row.type)\">Zmień status</button></span></td></tr></table></div></div><div class=col-xs-12 ng-if=\"!vm.formDataRealization.length>0\"><h2>Brak rozliczeń do wyświetlenia</h2></div></div></div></div></div></div>");
$templateCache.put("app/routes/panel/client/api/api.index.html","<div><div class=col-xs-12><div class=title></div><div class=row><div class=col-xs-12><h2>Dokumentacja</h2><div class=tile-stats><div class=icon><i class=\"fa fa-key\"></i></div><div class=count>Twój klucz API:</div><h3>{{vm.formData.apiKey}}</h3></div></div><div class=col-xs-12><div class=x_panel><h2>API v1.0.0</h2><div class=x_title><div class=clearfix></div></div><div class=\"margin-top-15 col-xs-12\"><div class=tile-stats><div class=icon><i class=\"fa fa-download\"></i></div><div class=count><a href=https://getpay.pl/api.pdf target=_blank>v1.0.0<div style=\"font-size: 20px\">Dokument techniczny API systemy GetPay</div></a></div></div><div class=tile-stats><div class=icon><i class=\"fa fa-download\"></i></div><div class=count><a href=https://getpay.pl/skrypt.rar download>v1.0.0<div style=\"font-size: 20px\">Skrypt PHP dla klienta</div></a></div></div></div></div></div></div></div><div class=clearfix></div></div>");
$templateCache.put("app/routes/panel/client/dashboard/dashboard.index.html","<div class=col-xs-12><div class=title><h3>Witaj! <button class=\"btn btn-default pull-right\" style=\"height: 32px\" ng-click=vm.getAll(null,true)><i class=\"fa fa-trash\"></i></button><md-input-container class=\"width-50 pull-right\"><label>Wybierz usługę</label><md-select ng-model=vm.selectedService name=pplSelect id=pplSelect data-md-container-class=selectdemoSelectHeader><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Użytkownik><md-option ng-value=item.id ng-click=vm.getAll(item.id) ng-repeat=\" item in  vm.serviceList | filter: vm.searchInput\">{{item.name}}</md-option></md-optgroup></md-select></md-input-container></h3></div></div><div class=\"row top_tiles\"><div class=\"animated flipInY col-sm-4 col-xs-12\"><div class=tile-stats><div class=icon><i class=\"fa fa-usd\"></i></div><div class=count><span ng-if=\"vm.statistics.saldo == null\">0</span> {{vm.statistics.saldo | customNumber}} zł</div><h3>Saldo konta</h3><p>Suma prowizji</p></div></div><div class=\"animated flipInY col-sm-4 col-xs-12\"><div class=tile-stats><div class=icon><i class=\"fa fa-comment-o\"></i></div><div class=count><span ng-if=\"vm.statistics.todayQuantity == null\">0</span> {{vm.statistics.todayQuantity | number}}</div><h3>Transakcji dzisiaj</h3><p>Ilość dzisiejszych transakcji</p></div></div><div class=\"animated flipInY col-sm-4 col-xs-12\"><div class=tile-stats><div class=icon><i class=\"fa fa-mail-reply\"></i></div><div class=count><span ng-if=\"vm.statistics.todayProfit == null\">0</span> {{vm.statistics.todayProfit | customNumber }} zł</div><h3>Zysk dzisiaj</h3><p>Suma dzisiejszego zysku</p></div></div></div><div class=\"x_panel canvas\"><div ng-if=\"vm.sumOfTransaction!=0||vm.sumOfProfits!=0||vm.sumOfRealizedTransaction!=0\"><div class=\"margin-top-15 col-xs-12\"><div style=\"overflow-y:auto; overflow-x: auto\"><table ng-table=vm.tableParams style=\"min-width: 600px\" class=\"table table-striped table-bordered table-hover jambo_table\"><tr align=center valign=center ng-repeat=\"row in $data\"><td align=center valign=center data-title=\"\'Nazwa usługi\'\" sortable>{{row.name}}</td><td data-title=\"\'Treść SMS\'\" sortable>{{row.content}}</td><td data-title=\"\'Numer premium\'\" sortable>{{row.number}}</td><td data-title=\"\'Kod zwrotny\'\" sortable>{{row.code}}</td><td data-title=\"\'Status kodu\'\" sortable><span ng-if=\"row.status==true\">Wykorzystany</span> <span ng-if=\"row.status==false\">Niewykorzystany</span></td><td data-title=\"\'Numer nadawcy\'\" style=\"min-width: 130px\" sortable>{{row.telephoneNumber.substring(0,3)}} {{row.telephoneNumber.substring(3,6)}} {{row.telephoneNumber.substring(6,9)}} {{row.telephoneNumber.substring(9)}}</td><td data-title=\"\'Prowizja\'\" sortable>{{row.amount}}</td><td data-title=\"\'Data realizacji\'\" style=\"min-width: 100px\" sortable>{{row.sendDate | date:\"dd.MM.yyyy HH:mm\" }}</td></tr></table></div></div><div class=x_content><div class=col-xs-12 style=\"padding: 0\"><div class=demo-container><div id=graph_line style=\"overflow-y:hidden; overflow-x: auto\"><div style=\"min-width: 800px\"><canvas height=300px width=1200px id=line class=\"chart chart-line\" chart-data=vm.data chart-labels=vm.labels chart-series=vm.series chart-options=vm.options chart-dataset-override=vm.datasetOverride style=\"max-height: none; max-width: 1800px\"></canvas></div></div></div></div></div></div><div class=col-xs-12 ng-if=\"!(vm.sumOfTransaction!=0||vm.sumOfProfits!=0||vm.sumOfRealizedTransaction!=0)\"><div style=\"text-align: center\"><h2>Brak danych, niestety nie masz jeszcze żadnych zysków.</h2></div></div></div>");
$templateCache.put("app/routes/panel/client/history/clientHistory.index.html","<div><div class=col-xs-12><div class=title><h3>Historia</h3></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2>Transakcje <small>Historia wszystkich transakcji</small></h2><div class=clearfix></div></div><form><div class=\"x_content overflow-x\"><div class=col-xs-12><div class=\"form-group col-xs-12 col-md-6\"><label>Data od</label><div class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} ng-model=vm.formData.dateFrom is-open=vm.openCalStart datepicker-options=dateOptions ng-required=true close-text=Close alt-input-formats=altInputFormats title=\"Data od\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.open()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-xs-12 col-md-6\"><label>Data do</label><div class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} ng-model=vm.formData.dateTo is-open=vm.openCalEnd datepicker-options=dateOptions ng-required=true close-text=Close alt-input-formats=altInputFormats title=\"Data do\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.open1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-xs-12 col-md-6\"><label>Numery Premium</label><md-input-container class=width-100><label>Wybierz numery</label><md-select ng-model=vm.form.numIds data-md-container-class=selectdemoSelectHeader multiple><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Numery><md-option ng-value=item ng-repeat=\"item in vm.numList | filter: vm.searchInput\">{{item.number}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"form-group col-xs-12 col-md-6\"><label>Usługa</label><md-input-container class=width-100><label>Wybierz usługi</label><md-select ng-model=vm.form.serviceIdList data-md-container-class=selectdemoSelectHeader multiple><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Usługa><md-option ng-value=item ng-repeat=\"item in vm.service | filter: vm.searchInput\">{{item.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"form-group col-xs-12 col-md-6\"><label>Kod</label><input type=text class=form-control ng-model=vm.formData.code title=Kod></div><div class=\"form-group col-xs-12 col-md-6\"><label>Numer telefonu</label><input type=number min=10000000 max=9999999999999 class=\"form-control phone\" ng-model=vm.formData.telephoneNumber title=Numer></div><div class=\"form-group col-xs-12 col-md-6\"><label>Status kodu</label><md-input-container class=width-100><label>Status</label><md-select ng-model=vm.formData.status data-md-container-class=selectdemoSelectHeader><md-optgroup label=Status><md-option ng-selected=\"item.status == null\" ng-value=item.status ng-repeat=\"item in vm.statusList\"><span ng-if=\"item.status == null\">Brak filtru</span> <span ng-if=\"item.status == true\">Wykorzystany</span> <span ng-if=\"item.status == false\">Niewykorzystany</span></md-option></md-optgroup></md-select></md-input-container></div></div></div></form><div class=col-xs-12><button class=\"pull-right btn btn-default\" ng-click=vm.getHistory()>Szukaj</button> <button class=\"pull-right btn btn-default\" ng-click=vm.sort()>Najczęstsze</button></div><div class=\"margin-top-15 col-xs-12\" ng-if=\"vm.history.length>0\"><div style=\"overflow-y:auto; overflow-x: auto\"><table ng-table=vm.tableParams style=\"min-width: 600px\" class=\"table table-striped table-bordered table-hover jambo_table\"><tr align=center valign=center ng-repeat=\"row in $data\"><td data-title=\"\'Nazwa usługi\'\" sortable>{{row.name}}</td><td data-title=\"\'Treść SMS\'\" sortable>{{row.content}}</td><td data-title=\"\'Numer premium\'\" sortable>{{row.number}}</td><td data-title=\"\'Kod zwrotny\'\" sortable>{{row.code}}</td><td data-title=\"\'Status kodu\'\" sortable><span ng-if=\"row.status==true\">Wykorzystany</span> <span ng-if=\"row.status==false\">Niewykorzystany</span></td><td data-title=\"\'Numer nadawcy\'\" style=\"min-width: 130px\" sortable>{{row.telephoneNumber.substring(0,3)}} {{row.telephoneNumber.substring(3,6)}} {{row.telephoneNumber.substring(6,9)}} {{row.telephoneNumber.substring(9)}}</td><td data-title=\"\'Prowizja\'\" sortable>{{row.amount}}</td><td data-title=\"\'Data realizacji\'\" style=\"min-width: 100px\" sortable>{{row.sendDate | date:\"dd.MM.yyyy HH:mm\" }}</td></tr></table></div></div></div></div></div></div><div class=clearfix></div></div>");
$templateCache.put("app/routes/panel/client/profile/profile.index.html","<div has-permission=people.view><div><div class=col-xs-12><div class=title><h3 class=pull-left>Profil</h3></div></div></div><div class=row></div><ul class=\"nav nav-tabs bar_tabs profile-tab dflex\" role=tablist><li role=presentation class=\"active cursor-pointer text-no-wrap\"><a data-target=#client id=client-info role=tab data-toggle=tab aria-expanded=true>Dane użytkownika</a></li></ul><div class=\"tab-content profile-tab-content\"><div role=tabpanel class=\"tab-pane fade active in\" id=client aria-labelledby=home-tab><div class=\"col-xs-12 col-sm-6\"><div class=text-center><h3>{{vm.formDataInfo.name}}</h3></div><div class=profile-info><ul class=\"list-unstyled user_data\"><li><i class=\"fa fa-map-marker user-profile-icon\"></i> {{vm.formDataInfo.address}}, {{vm.formDataInfo.postalCode}} {{vm.formDataInfo.location}}</li><li class=m-top-xs><i class=\"fa fa-external-link user-profile-icon\"></i> {{vm.formDataInfo.mail}}</li><li class=m-top-xs><i class=\"fa fa-unlock-alt user-profile-icon\"></i> <span ng-if=\"vm.formDataInfo.apiKey === null\">Brak klucza API</span> <span ng-if=\"vm.formDataInfo.apiKey !== null\">{{vm.formDataInfo.apiKey}}</span></li></ul></div><h4 has-permission=people.update>Zmień hasło:</h4><form class=\"form-horizontal form-label-left\" has-permission=people.update><div class=form-group><div class=form-group><div class=\"col-xs-12 no-padding\"><input type=password class=form-control placeholder=\"Stare hasło\" data-ng-model=vm.oldPassword name=oldPassword></div></div><div class=form-group><div class=\"col-xs-12 no-padding\"><input type=password class=form-control placeholder=\"Nowe haslo\" data-ng-model=vm.passwd name=passwd></div></div><div class=form-group><div class=\"col-xs-12 no-padding\"><input type=password class=form-control placeholder=\"Potwierdź haslo\" data-ng-model=vm.checkpasswd name=checkpasswd></div></div><button ng-click=vm.changePassword() ng-disabled=\"(vm.passwd!=vm.checkpasswd) || (vm.passwd==\'\')\" class=\"btn btn-info pull-right btn-no-margin-right\">Zmień hasło</button></div></form></div><div class=\"col-xs-12 col-sm-6\"><div class=col-xs-12><div class=x_title has-permission=people.update><h4>Informacje o koncie</h4></div><div><form class=form-row-seperated name=form has-permission=people.update><div class=\"form-group col-xs-12\"><label class=control-label>Typ Konta</label><md-input-container class=width-100><label>Typ Konta</label><md-select ng-disabled=true ng-model=vm.formData.type data-md-container-class=selectdemoSelectHeader md-on-close=vm.checkPlaceHolder()><md-optgroup label=\"Typ Konta\"><md-option ng-value=item.type ng-repeat=\"item in vm.filter \">{{item.type| SingUpType}}</md-option></md-optgroup></md-select></md-input-container></div><div class=\"form-group col-xs-12\" data-ng-class=\"{\'has-error\' : form.name.$invalid && !form.name.$pristine}\"><label class=control-label>{{ vm.placeholder.name }}</label><input type=text class=form-control placeholder=\"{{ vm.placeholder.name | translate }}\" data-ng-model=vm.formData.name ng-disabled=true name=name required></div><div ng-if=\"vm.formData.type==\'P\'\" class=\"form-group col-xs-12 animate-if\" data-ng-class=\"{\'has-error\' : form.identification.$invalid && !form.identification.$pristine}\"><label class=control-label>{{vm.placeholder.identification }}</label><input type=text class=\"form-control animate-if\" placeholder=\"{{ \'NIP*\' | translate }}\" data-ng-model=vm.formData.identification ng-disabled=true ng-if=\"vm.formData.type==\'P\'\" name=identification ng-required=\"vm.formData.type==\'P\'\"></div><div class=\"form-group col-xs-12\" data-ng-class=\"{\'has-error\' : form.address.$invalid && !form.address.$pristine}\"><label class=control-label>Adres</label><input type=text class=form-control placeholder=\"{{ \'Address\' | translate }}\" data-ng-model=vm.formData.address ng-disabled=true name=address required></div><div class=\"form-group col-xs-6 col-sm-5 col-md-4\" data-ng-class=\"{\'has-error\' : form.postalCode.$invalid && !form.postalCode.$pristine}\"><label class=control-label>Kod pocztowy</label><input type=text class=form-control placeholder=\"{{ \'Postal code\' | translate }}\" data-ng-model=vm.formData.postalCode name=postalCode ng-model-options=\"{allowInvalid: true}\" ng-disabled=true pattern=\\d{2}-\\d{3} mask=99-999 maxlength=6 ng-change=vm.postPattern() required></div><div class=\"form-group col-xs-6 col-sm-7 col-md-8\" data-ng-class=\"{\'has-error\' : form.location.$invalid && !form.location.$pristine}\"><label class=control-label>Miejscowość</label><input type=text class=form-control placeholder=\"{{ \'Location\' | translate }}\" data-ng-model=vm.formData.location ng-disabled=true name=location required></div><div class=\"form-group col-xs-12\" data-ng-class=\"{\'has-error\' : form.bankAccountNumber.$invalid && !form.bankAccountNumber.$pristine && vm.editing}\"><label class=control-label>Numer konta bankowego</label><input type=text class=form-control placeholder=\"{{ \'Numer konta bankowego\' | translate }}\" data-ng-model=vm.formData.bankAccountNumber name=bankAccountNumber maxlength=32 ng-change=vm.inputSpaces() required ng-disabled=!vm.editing></div></form><div class=col-xs-12><button class=\"btn btn-primary pull-right btn-no-margin-right\" ng-show=vm.editing data-ng-click=vm.save() has-permission=people.update data-ng-disabled=form.$invalid>Zapisz zmiany</button> <button class=\"btn btn-default\" ng-show=!vm.editing ng-click=vm.edit()>Edytuj</button> <button ng-show=vm.editing class=\"btn btn-danger\" ng-click=vm.cancelEdit()>Anuluj Edycje</button></div></div></div></div></div></div></div>");
$templateCache.put("app/routes/panel/client/services/services.create.html","<div class=modal-header has-permission=service.create><h3 class=modal-title>Tworzenie usługi</h3></div><div class=modal-body><ul class=\"nav nav-tabs bar_tabs profile-tab dflex\" role=tablist><li role=presentation class=\"active cursor-pointer text-no-wrap\"><a data-target=#serviceInfoo id=serviceInfo role=tab data-toggle=tab aria-expanded=true>Dane usługi</a></li><li role=presentation class=\"cursor-pointer text-no-wrap\"><a data-target=#smss role=tab id=sms data-toggle=tab aria-expanded=false>SMS</a></li></ul><div class=\"tab-content profile-tab-content\"><div role=tabpanel class=\"tab-pane fade active in\" id=serviceInfoo aria-labelledby=home-tab><form class=form-row-seperated name=form2><div class=\"form-group col-xs-12 no-padding\" data-ng-class=\"{\'has-error\' : form2.name.$invalid && !form2.name.$pristine}\"><label class=\"col-xs-12 control-label\">{{ \'Nazwa\' | translate }}</label><div class=col-xs-12><input type=text class=form-control placeholder=\"{{ \'Nazwa usługi\' | translate }}\" data-ng-model=vm.formData.name name=name required></div></div><div class=\"form-group col-xs-12 no-padding\" data-ng-class=\"{\'has-error\' : (form2.content.$invalid && !form2.content.$pristine)||(!form2.content.$pristine&&!vm.check)}\"><label class=\"col-xs-12 control-label\">{{ \'Treść SMS \' | translate }}</label><div class=col-xs-12><div class=input-group><span class=\"input-group-addon empty-btn\" id=basic-addon1>GPAY.</span> <input type=text class=form-control placeholder=\"{{ \'Treść SMS (bez polskich znaków)\' | translate }}\" data-ng-model=vm.formData.content name=content ng-change=\"vm.block=true\" ng-blur=vm.CheckContent(vm.formData.content) required></div></div></div><div class=\"form-group col-xs-12 no-padding\" data-ng-class=\"{\'has-error\' : form2.description.$invalid && !form2.description.$pristine}\"><label class=\"col-xs-12 control-label\">{{ \'Opis\' | translate }}</label><div class=col-xs-12><textarea style=\"max-width: 530px\" class=form-control placeholder=\"{{ \'Krótki opis usługi, jeśli usługa wymaga zalogowania do sklepu, prosimy o wpisanie danych dostępowych\' | translate }}\" data-ng-model=vm.formData.description name=description required>\r\n            </textarea></div></div><div class=\"col-xs-12 no-padding\" style=\"margin-bottom: -12px\"><div class=\"form-group col-xs-12 no-padding\" data-ng-class=\"{\'has-error\' : form.www.$invalid && !form.www.$pristine}\"><label class=\"col-xs-12 control-label\">{{ \'Strona WWW\' | translate }}</label><div ng-repeat=\"row in vm.www\"><div class=col-xs-12><input type=text class=form-control placeholder=\"{{ \'Strona na której będzie prowadzona sprzedaż\' | translate }}\" data-ng-model=vm.www[$index].web name=www required></div></div></div></div><div class=col-xs-12></div></form></div><div role=tabpanel class=\"tab-pane fade in\" id=smss aria-labelledby=home-tab><form class=form-row-seperated name=form3><div class=\"form-group col-xs-12 no-padding\" style=\"margin-top: 10px\" data-ng-class=\"{\'has-error\' : form3.classification.$invalid && !form3.classification.$pristine}\"><label class=\"col-xs-12 control-label\">Klasyfikacja</label><div class=col-xs-12><md-radio-group ng-model=vm.numList><md-radio-button class=\"md-primary pull-left\" aria-checked=vm.numListB ng-value=vm.numListB ng-click=vm.clearNumbers(vm.numListB)>Zwykła</md-radio-button><md-radio-button class=\"md-primary pull-left\" aria-checked=vm.numListA ng-value=vm.numListA ng-click=vm.clearNumbers(vm.numListA) style=\"margin-left: 20px\">+18</md-radio-button></md-radio-group></div></div><div class=\"form-group col-xs-12 no-padding\"><label class=\"col-xs-12 control-label\">{{ \'Numery Premium\' | translate }}</label><md-input-container class=width-100><label>Numery premium</label><md-select ng-model=vm.numbers data-md-container-class=selectdemoSelectHeader multiple><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Search... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=\"Numery premium\"><md-option ng-value=item ng-repeat=\"item in vm.numList | filter: vm.searchInput\">{{item.number}}<span class=option-hack> {{item.value | customNumber}}zł {{vm.round(item.value)}}</span></md-option></md-optgroup></md-select></md-input-container></div><div class=\"form-group col-xs-12 no-padding\" data-ng-class=\"{\'has-error\' : form3.responseContent.$invalid && !form3.responseContent.$pristine || (vm.responsecheck == false &&!form3.responseContent.$pristine)}\"><label class=\"col-xs-12 control-label\">{{ \'Treść wiadomości zwrotnej\' | translate }} <span style=\"display: block\" ng-if=\"form3.responseContent.$invalid && !form3.responseContent.$pristine || (vm.responsecheck == false &&!form3.responseContent.$pristine)\">W miejsce kodu wpisz [kod]</span></label><div class=col-xs-12><input type=text class=form-control maxlength=135 placeholder=\"{{ \'W miejsce kodu wpisz [kod]\' | translate }}\" data-ng-model=vm.formData.responseContent ng-change=vm.checkResponse() name=responseContent required></div></div><div class=\"form-group col-xs-12 no-padding\" data-ng-class=\"{\'has-error\' : form3.staticResponse.$invalid && !form3.staticResponse.$pristine}\"><label class=\"col-xs-12 control-label\">{{ \'Generowanie kodów\' | translate }}</label><div class=col-xs-12><md-radio-group ng-model=vm.generate><md-radio-button class=md-primary aria-checked=\"\'A\'\" ng-value=\"\'A\'\">Automatycznie</md-radio-button><!--              <md-radio-button class=\"md-primary\" aria-checked=\"\'S\'\"\r\n                                             ng-value=\"\'S\'\" style=\"margin-top: 10px;\">\r\n                              Stała odpowiedź\r\n                            </md-radio-button>--></md-radio-group></div><div class=col-xs-12 ng-if=\"vm.generate == \'S\'\"><input class=form-control required name=staticResponse type=text ng-model=vm.formData.generateCode title=\"Stała odpowiedź\"></div></div></form></div></div></div><div class=modal-footer><button class=\"btn btn-primary pull-right\" data-ng-click=vm.ok() data-ng-disabled=\"form2.$invalid || form3.$invalid || vm.numbers.length==0 || !vm.check || vm.block || vm.responsecheck == false;\">Dodaj</button> <button class=\"btn btn-warning pull-right\" data-ng-click=vm.cancel()>Anuluj</button></div>");
$templateCache.put("app/routes/panel/client/services/services.delete.html","<div class=modal-header><h3 class=modal-title>Edycja</h3></div><div class=modal-body><form class=form-row-seperated name=form><div class=row><div class=\"col-xs-12 text-center\">{{\'Jesteś pewny że chcesz usunąć tę usługę\' | translate}}?<br><br><button class=\"btn btn-primary\" data-ng-click=vm.ok()>Usuń</button> <button class=\"btn btn-warning\" data-ng-click=vm.cancel()>Anuluj</button></div></div></form></div>");
$templateCache.put("app/routes/panel/client/services/services.details.html","<div class=modal-header><h3 class=modal-title>Szczegóły</h3></div><div class=modal-body><div class=row></div><ul class=\"nav nav-tabs bar_tabs profile-tab\" role=tablist><li role=presentation class=\"active cursor-pointer\"><a data-target=#data id=client-info role=tab data-toggle=tab aria-expanded=true>Dane usługi</a></li><li role=presentation class=cursor-pointer><a data-target=#sms role=tab id=client-edit data-toggle=tab aria-expanded=false>SMS</a></li></ul><div class=\"tab-content profile-tab-content\"><div role=tabpanel class=\"tab-pane fade active in\" id=data aria-labelledby=home-tab><!-- DANE USŁUGI --><div class=col-xs-12><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Sekretny klucz API:</div><div class=\"col-xs-8 data-details\"><span ng-if=\"vm.dane.apiSecret != null\">{{vm.dane.apiSecret}} </span><span ng-if=\"vm.dane.apiSecret == null\">Brak numeru</span></div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Nazwa:</div><div class=\"col-xs-8 data-details\">{{vm.dane.name}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Treść SMS:</div><div class=\"col-xs-8 data-details\">{{vm.dane.prefix}}.{{vm.dane.content}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Opis:</div><div class=\"col-xs-8 data-details\">{{vm.dane.description}}</div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Strona WWW:</div><div class=\"col-xs-8 data-details\"><a ng-repeat=\"www in vm.dane.www\">{{www}}</a></div></div></div></div><div role=tabpanel class=\"tab-pane fade in\" id=sms aria-labelledby=home-tab><!-- SMS --><div class=col-xs-12><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Klasyfikacja:</div><div class=\"col-xs-8 data-details\"><span ng-if=\"vm.dane.classification == \'t\'\">+18 </span><span ng-if=\"vm.dane.classification == \'f\'\">Zwykła</span></div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Numery SMS:</div><div class=\"col-xs-8 data-details\"><span ng-if=\"vm.dane.numbers.length == 0\">Brak numerów</span><div ng-if=\"vm.dane.numbers.length > 0\"><ul><li ng-repeat=\"num in vm.dane.numbers\">{{num}}</li></ul></div></div></div><div class=\"row data-presentation\"><div class=\"col-xs-4 text-right data-label\">Treść SMS zwrotnego:</div><div class=\"col-xs-8 data-details\"><span>{{vm.dane.responseContent}}</span></div></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-warning pull-right\" data-ng-click=vm.cancel()>Zamknij</button></div>");
$templateCache.put("app/routes/panel/client/services/services.index.html","<div class=col-xs-12 has-permission=service.view><div class=title><h3 class=pull-left>Usługi SMS</h3></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=x_title><h2 class=pull-left>Moje usługi</h2><button has-permission=sms.create ng-click=vm.create() class=\"pull-right btn btn-info\">Dodaj usługę</button><div class=clearfix></div></div><div class=x_content><div class=table-responsive ng-if=\"vm.tableData.length>0\"><table ng-table=vm.tableParams class=\"table table-bordered table-striped table-hover jambo_table\"><tr ng-repeat=\"row in $data\"><td data-title=\"\'Nazwa Usługi\'\" sortable>{{row.name}}</td><td data-title=\"\'Treść SMS\'\" sortable>{{row.prefix}}.{{row.content}}</td><td data-title=\"\'Status\'\" sortable><span ng-show=\"row.status==\'A\'\">Aktywny</span> <span ng-show=\"row.status==\'N\'\">Nieaktywny</span></td><td class=\"text-center wide-column\" data-title=\"\'Akcja\'\"><button ng-click=vm.details(row.id) class=\"btn btn-warning btn-sm\">Szczegóły</button></td></tr></table></div></div><div class=row></div></div></div><div class=col-xs-12 has-permission=sms.view><div class=title><h3>Generowanie testowych SMS\'ów</h3></div><div ng-show=\"vm.generateSucces==\'created\'\" class=\"alert alert-success alert-dismissible fade in\" role=alert><button class=close ng-click=\"vm.generateSucces=\'dontShow\'\"><span aria-hidden=true>×</span></button> <strong>Stworzono</strong> testowego SMS\'a Numer: {{vm.temp.telephoneNumber}} Kod: {{ vm.temp.code}}</div><div ng-show=\"vm.generateSucces==\'notCreated\'\" class=\"alert alert-danger alert-dismissible fade in\" role=alert><button class=close ng-click=\"vm.generateSucces=\'dontShow\'\"><span aria-hidden=true>×</span></button> <strong>Nie udało się</strong> stworzyć SMS\'a testowego.</div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel has-permission=sms.create><div class=x_title><h2>Wygeneruj testowe SMS\'y</h2><div class=clearfix></div></div><form><div class=col-xs-6><label>Usługa</label><md-input-container class=width-100><label>Wybierz usługe</label><md-select ng-model=vm.form.serviceIdListFG data-md-container-class=selectdemoSelectHeader><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Usługa><md-option ng-click=\"vm.getNumbersForService(item) ;vm.disableGenerator(item,undefined)\" ng-value=item ng-repeat=\"item in vm.serviceForGenerator | filter: vm.searchInput\">{{item.name}}</md-option></md-optgroup></md-select></md-input-container></div><div class=col-xs-6 ng-show=vm.numshow><label>Numery Premium</label><md-input-container class=width-100><label>Wybierz numery</label><md-select ng-model=vm.form.numIdsFG data-md-container-class=selectdemoSelectHeader><md-select-header class=demo-select-header><input ng-model=vm.searchInput type=search ng-keydown=$event.stopPropagation() placeholder=Szukaj... class=\"demo-header-searchbox md-text\"></md-select-header><md-optgroup label=Numer><md-option ng-click=vm.disableGenerator(vm.form.serviceIdListFG,item) ng-value=item ng-repeat=\"item in vm.formGenerator.numbers | filter: vm.searchInput\">{{item.number}}</md-option></md-optgroup></md-select></md-input-container></div></form><div class=col-xs-12><button class=\"pull-right btn btn-success\" style=margin-top:10px data-ng-disabled=vm.blockGenerator ng-click=vm.generateSMS()>Generuj</button></div></div></div></div></div><div class=row></div></div></div>");
$templateCache.put("app/routes/panel/client/settlements/settlements.index.html","<div has-permission=realization.view><div class=col-xs-12><div class=title><h3>Rozliczenia i Finanse</h3></div></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=x_panel><div class=col-xs-12><div><h2>Saldo konta: <span ng-if=\"vm.formDataFinance.accountBalance == null\"><b>{{0 | customNumber}}</b></span> <b>{{vm.formDataFinance.accountBalance | customNumber}}</b> zł</h2><div ng-show=\"vm.userData.type==\'P\' && vm.formDataFinance.status==\'A\'\" class=\"alert alert-info alert-dismissible fade in\" role=alert><strong>W przypadku klienta prywatnego:</strong><br>Wypłatę można realizować od kwoty 50 złotych.<br><br><strong>W przypadku klienta firmowego:</strong><br>Wypłatę można realizować od kwoty 50 złotych.<br>Po zleceniu dyspozycji wypłaty, prosimy o wystawienie faktury VAT<br><br>i przesłanie jej na naszą skrzynkę pocztową: <a style=\"color: #fff\" href=mailto:kontakt@getpay.pl>kontakt@getpay.pl</a><br><br>Dane do faktury:<br>GetPay Magdalena Flak<br>Szprudowo 26a, 83-140 Gniew<br>NIP: 5931837300<br>Nazwa usługi: Promocja i dostarczenie treści do serwisów multimedialnych<br></div><div ng-if=\"vm.formDataFinance.status==\'N\'\" class=jumbotron role=alert>Potwierdzenie danych jest jednorazowym etapem, dane podane podczas rejestracji muszą zgadzać się z danymi konta bankowego.<br>Dodać i korzystać z usługi można nie mając potwierdzonych danych.<br><br>Przelew należy wykonać na poniższe dane:<br><br>Nazwa odbiorcy: GetPay Magdalena Flak<br>Numer konta bankowego: 42 1140 2004 0000 3002 8039 1202<br>Adres: Szprudowo 26a, 83-140 Gniew<br>Kwota: 0.01 złotych (1 grosz)<br>Tytułem: Aktywacja rozliczeń - {{vm.userData.id}}</div><hr><h2 class=pull-left>Rozliczenia</h2><button has-permission=realization.create ng-if=\"vm.formDataFinance.status==\'A\'\" data-ng-disabled=\"vm.disabled || vm.formDataFinance.accountBalance<50\" class=\"btn btn-info pull-right\" ng-click=vm.all(vm.formDataFinance)>Wypłać</button><div class=col-xs-12 ng-if=\"!vm.formDataRealization.length>0\"><h2>Brak rozliczeń do wyświetlenia</h2></div><div class=\"col-xs-12 no-padding\" ng-if=\"vm.formDataRealization.length>0\"><div class=table-responsive><table ng-table=vm.tableParams class=\"table table-striped table-bordered table-hover jambo_table thead-no-wrap\"><tr ng-repeat=\"row in $data\"><td style=\"width: 200px\" class=text-center data-title=\"\'Kwota\'\" sortable>{{row.value | customNumber}} zł</td><td data-title=\"\'Data realizacji\'\" class=text-center sortable><span ng-show=row.realizationDate>{{row.realizationDate | date:\"dd.MM.yyyy HH:mm\"}} </span><span ng-hide=row.realizationDate>-</span></td><td data-title=\"\'Status\'\" sortable>{{row.status | SettlementsStatus}}</td></tr></table></div></div></div></div></div></div></div></div>");}]);